{
  "unavailable": {
    "requestTitle": "Solicitud no disponible",
    "requestDescription": "Esta solicitud ya no está disponible. Puede haberse eliminado o el enlace puede ser incorrecto.",
    "requestAction": "Ir a mis solicitudes",
    "budgetTitle": "Presupuesto no disponible",
    "budgetDescription": "Este presupuesto ya no está disponible. Puede haberse eliminado o el enlace puede ser incorrecto.",
    "budgetAction": "Ir a presupuestos"
  },
  "identityCandidates": {
    "title": "Atlas te propone estas alternativas",
    "choose": "Seleccionar este producto",
    "searchLabel": "Código, referencia, marca o texto visible",
    "search": "Buscar con Atlas",
    "reviewPending": "Atlas no ha podido identificar el producto con lo que leyó en el documento. Hay que corregir el código, la referencia, la marca o la descripción tal como aparecen en el documento.",
    "pendingTitle": "Identificación en curso",
    "identityPending": "Atlas todavía no ha publicado el siguiente paso para identificar este producto.",
    "readValues": "Lo que Atlas leyó en el documento:",
    "askAgainHint": "Consulta de nuevo a Atlas para abrir el formulario y continuar.",
    "askAgain": "Consultar de nuevo a Atlas",
    "correctTitle": "Corregir la lectura",
    "correctHint": "Corrige únicamente los datos visibles en el documento. Atlas volverá a buscar alternativas sin cambiar la cantidad ni la unidad.",
    "confirmCorrection": "Confirmar corrección",
    "fields": {
      "source_code": "Código leído",
      "source_reference": "Referencia leída",
      "source_brand": "Marca leída",
      "source_description": "Descripción leída",
      "raw_text": "Texto completo leído"
    },
    "selecting": "Seleccionando…"
  },
  "documentQuantity": {
    "commercialPending": "Revisión comercial de la unidad de compra",
    "commercialHint": "El equipo comercial confirmará cómo se compran estos productos: {{products}}. No tienes que hacer nada: puedes continuar y se enviarán marcados para esa revisión.",
    "pending": "Confirma las cantidades pendientes antes de continuar. Los demás productos no necesitan esta revisión.",
    "review": "Revisar cantidad",
    "missing": "Cantidad pendiente"
  },
  "admin": {
    "atlasSkills": {
      "title": "Estado de Atlas y lectores",
      "refresh": "Comprobar",
      "hint": "Datos de la API, evidencia de lecturas del Portal e inventario de skills, consultados por separado.",
      "installedVersion": "Instalada",
      "activeVersion": "Activa en Atlas",
      "latestVersion": "Última comunicada por Atlas",
      "channel": "Canal disponible",
      "unknownValue": "No confirmado",
      "checked": "Última consulta: {{date}}",
      "observed": "Inventario de Atlas: {{date}}",
      "empty": "Atlas ha confirmado un inventario vacío.",
      "noVisibleSkills": "No hay skills para mostrar en este bloque del Portal.",
      "unsupported": "Atlas todavía no publica el inventario de versiones en su API.",
      "not_configured": "Configura y activa la conexión con Atlas para consultar sus skills.",
      "unauthorized": "Atlas no ha autorizado la consulta. Revisa la conexión de la API.",
      "unavailable": "No se ha podido consultar Atlas. Puedes volver a comprobarlo.",
      "invalid_response": "Atlas no ha devuelto un inventario válido. No mostramos versiones sin confirmar.",
      "states": {
        "current": "Actualizada",
        "update_available": "Actualización disponible",
        "development": "En desarrollo",
        "inactive": "Inactiva",
        "unknown": "Sin confirmar"
      },
      "channels": {
        "stable": "Estable",
        "development": "Desarrollo",
        "unknown": "No confirmado"
      },
      "runtimeTitle": "API de Atlas",
      "apiVersion": "Versión declarada de la API",
      "apiRelease": "Release",
      "recognitionSchema": "Contrato de reconocimiento",
      "documentContract": "Contrato documental",
      "runtimeMismatch": "La huella de código cargado no coincide con la versión declarada por Atlas. No se puede confirmar que esa release esté ejecutándose.",
      "runtimeUnavailable": "Atlas no ha confirmado la versión de la API en esta consulta.",
      "readerTitle": "Último lector documental observado",
      "readerLean": "Lean: hay evidencia explícita en la última lectura documental guardada.",
      "readerNotObserved": "No hay evidencia comprobable para identificar el lector documental.",
      "readerVersion": "Versión del lector",
      "readerVersionUnknown": "Sin versión confirmada en esta consulta",
      "readerObservedAt": "Resultado de lectura observado: {{date}} (hora de España)",
      "readerObservationHint": "Esta evidencia corresponde a un resultado guardado del Portal. No acredita la configuración actual del servicio ni sustituye una versión publicada por Atlas.",
      "skillsTitle": "Inventario de skills",
      "skillsHint": "Versiones comunicadas por Atlas. Una skill de fotografías no identifica por sí sola el lector de PDF o Excel.",
      "versionConflictLabel": "Verificar inventario",
      "versionConflictHint": "Atlas comunica como última una versión anterior a la instalada o activa. Se conservan sus valores, pero no se confirma que la skill esté actualizada."
    },
    "approve": "Aprobar",
    "approveConfirmText": "Se creará la empresa y el usuario, y podrá acceder al portal de inmediato.",
    "approveConfirmTitle": "¿Aprobar el alta?",
    "approved": "Alta aprobada",
    "assistantOff": "Desactivado",
    "assistantOn": "Activo",
    "assistantReachable": "Servicio accesible",
    "assistantSection": "Asistente Atlas",
    "assistantToggle": "Mostrar el asistente a los clientes",
    "assistantToggleHint": "Al desactivarlo desaparece del menú y el portal deja de aceptar consultas. El servicio sigue en marcha, así que puedes volver a activarlo cuando quieras.",
    "assistantUnreachable": "No se alcanza el servicio",
    "assistantAnalyticsTitle": "Qué consultan los clientes a Atlas",
    "assistantAnalyticsSubtitle": "Histórico acumulado de consultas para detectar necesidades y productos que requieren más ayuda.",
    "assistantAnalyticsAnonymous": "Datos agregados",
    "assistantAnalyticsQuestions": "Preguntas realizadas",
    "assistantAnalyticsChats": "Chats iniciados",
    "assistantAnalyticsCoverage": "Consultas ligadas a productos",
    "assistantAnalyticsTopProducts": "Productos que generan más dudas",
    "assistantAnalyticsTopProductsHint": "Productos identificados y validados por Atlas en sus respuestas.",
    "assistantAnalyticsQuestionTypes": "Qué pregunta la gente",
    "assistantAnalyticsQuestionTypesHint": "Motivo principal de cada consulta, agrupado por intención.",
    "assistantAnalyticsTopics": "Temas más consultados",
    "assistantAnalyticsTopicsHint": "Áreas técnicas que aparecen con mayor frecuencia.",
    "assistantAnalyticsTimeline": "Actividad diaria",
    "assistantAnalyticsTimelineHint": "Evolución de consultas y conversaciones durante el periodo conservado.",
    "assistantAnalyticsTimelineValue": "{{questions}} consultas · {{sessions}} chats",
    "assistantAnalyticsEmpty": "Todavía no hay suficientes consultas para mostrar esta clasificación.",
    "assistantAnalyticsPrivacyTitle": "Privacidad por diseño",
    "assistantAnalyticsPrivacyText": "Esta vista no recibe nombres, correos ni textos completos de las conversaciones. Solo muestra recuentos agregados.",
    "auditAction": "Acción",
    "auditEmpty": "Sin actividad registrada",
    "auditEmptyText": "Aquí se recoge todo lo que ocurre en el portal.",
    "auditEntity": "Elemento",
    "auditWho": "Quién",
    "budgetActions": "Acciones del presupuesto",
    "budgetCompany": "Empresa",
    "budgetValidUntil": "Válido hasta",
    "budgetsEmpty": "No hay presupuestos que encajen con lo que buscas.",
    "budgetsHint": "Todos los presupuestos creados desde el Portal, con su autor y fecha de creación.",
    "budgetsSearch": "Buscar por referencia o proyecto",
    "budgetsTitle": "Presupuestos del Portal",
    "colApplicant": "Solicitante",
    "colCompany": "Empresa",
    "colOrigin": "Origen",
    "colWaiting": "Solicitada",
    "extend": "Prorrogar validez",
    "extendDone": "Validez prorrogada.",
    "extendField": "Nueva fecha de validez",
    "extendText": "Elige hasta cuándo sigue siendo válido «{{ref}}». Se avisará al cliente.",
    "extendTitle": "Prorrogar la validez",
    "hermesApiKey": "Clave de API",
    "hermesApiKeyHint": "Se envía a Atlas para acreditar al portal.",
    "hermesAutoSubmit": "Encargar al enviar la solicitud",
    "hermesAutoSubmitHint": "Apagado, el encargo lo hace Adaltra a mano.",
    "hermesAutoSubmitNeedsSecret": "Necesita el secreto de firma: sin él, la respuesta de Atlas no puede comprobarse.",
    "hermesBaseUrl": "Dirección de la API",
    "hermesCallbackSecret": "Secreto de firma",
    "hermesCallbackSecretHint": "Con él firma Atlas lo que devuelve. No es la clave de API.",
    "hermesCallbackUrl": "Atlas debe responder a",
    "hermesClear": "Borrar",
    "hermesEnabled": "Integración activa",
    "hermesEnabledHint": "Apagada, el portal ni encarga ni acepta respuestas.",
    "hermesHint": "Atlas redacta los presupuestos a partir de las solicitudes enviadas y los crea en Ada-quote, donde un comercial los revisa.",
    "hermesSaved": "Conexión guardada.",
    "hermesSecretPlaceholder": "Escribe para cambiarlo",
    "hermesSecretSet": "Guardado",
    "hermesSecretUnset": "Sin configurar",
    "hermesTest": "Probar conexión",
    "hermesTestFail": {
      "missingBaseUrl": "Falta la dirección de la API.",
      "missingApiKey": "Falta la clave de API.",
      "unauthorized": "Atlas rechaza la clave.",
      "badStatus": "Atlas responde, pero con error ({{status}}).",
      "timeout": "Atlas no ha contestado a tiempo.",
      "unreachable": "No se ha podido conectar con esa dirección."
    },
    "hermesTestOk": "Atlas responde correctamente.",
    "hermesTesting": "Probando…",
    "hermesTimeout": "Espera máxima (ms)",
    "hermesTitle": "Agente Atlas",
    "onlyStaff": "Esta zona es solo para el personal de Adaltra.",
    "registrationsEmpty": "No hay altas pendientes",
    "registrationsEmptyText": "Aquí aparecerán las solicitudes de acceso de nuevos clientes.",
    "reject": "Rechazar",
    "rejectConfirmText": "La solicitud quedará marcada como rechazada y no se creará ninguna cuenta.",
    "rejectConfirmTitle": "¿Rechazar el alta?",
    "rejected": "Alta rechazada",
    "remind": "Reenviar el aviso",
    "remindDone": "Aviso reenviado al cliente.",
    "sectionNav": "Secciones de administración",
    "settingsSaved": "Ajustes guardados",
    "notificationsSaved": "Configuración de notificaciones guardada.",
    "notificationChannelsTitle": "Canales para avisos generales",
    "notificationChannelsHint": "Elige por dónde reciben los clientes los avisos generados por el portal.",
    "pushBroadcastTitle": "Enviar una notificación push",
    "pushBroadcastHint": "Redacta un aviso breve para todas las personas que hayan activado las notificaciones en algún dispositivo.",
    "pushBroadcastModalHint": "Se enviará a los dispositivos suscritos ({{count}} en total). Revisa el contenido antes de confirmar.",
    "composePush": "Redactar notificación",
    "registeredUsers": "Usuarios registrados",
    "pushSubscribedUsers": "Con push activo",
    "pushConfigureBeforeSend": "Configura y activa primero las claves push para poder enviar el aviso.",
    "pushMessageTitle": "Título de la notificación",
    "pushMessageBody": "Mensaje",
    "sendPushNow": "Enviar notificación",
    "pushBroadcastSent": "Notificación enviada a {{count}} dispositivos.",
    "emailChannelTitle": "Avisos generales por correo",
    "emailChannelHint": "Controla por separado si los avisos automáticos del portal también se envían por correo.",
    "channelPortal": "Portal y campana",
    "channelPortalHint": "Guarda el aviso en el centro de notificaciones.",
    "channelEmail": "Correo electrónico",
    "channelEmailHint": "Envía una copia mediante el servidor SMTP.",
    "channelPush": "Notificación push",
    "channelPushHint": "Muestra el aviso en el dispositivo aunque Atlas esté cerrado.",
    "smtpTitle": "Servidor de correo SMTP",
    "smtpHint": "Configura el servidor que envía avisos y correos transaccionales del portal.",
    "smtpUrl": "URL SMTP (opcional)",
    "smtpUrlHint": "Si se indica, sustituye al servidor y puerto separados.",
    "smtpUrlConfigured": "Hay una URL SMTP protegida configurada. Se conservará mientras no indiques un servidor distinto.",
    "smtpHost": "Servidor",
    "smtpPort": "Puerto",
    "smtpSecure": "Usar conexión segura directa (TLS)",
    "smtpUser": "Usuario",
    "smtpPassword": "Contraseña",
    "smtpPasswordHint": "Déjala vacía para conservar la contraseña guardada.",
    "smtpFrom": "Remitente",
    "smtpReplyTo": "Responder a (opcional)",
    "smtpEnabled": "Activar el envío de correo",
    "smtpTestSent": "Correo de prueba enviado a {{email}}.",
    "pushTitle": "Notificaciones push",
    "pushHint": "Configura las claves VAPID estables con las que Atlas identifica este servidor ante los navegadores.",
    "pushPublicKey": "Clave pública VAPID",
    "pushPrivateKey": "Clave privada VAPID",
    "pushPrivateKeyHint": "Nunca se muestra de nuevo. Déjala vacía para conservarla.",
    "pushSubject": "Contacto del servicio",
    "pushSubjectHint": "Normalmente una dirección como mailto:soporte@adaltra.com.",
    "pushEnabled": "Activar notificaciones push",
    "generateVapid": "Generar claves",
    "sendTest": "Enviar prueba",
    "pushTestSent": "Notificación de prueba enviada a este dispositivo.",
    "pushTestNoSubscription": "La configuración funciona, pero este usuario aún no tiene ningún dispositivo suscrito.",
    "configurationFromEnvironment": "Esta configuración procede actualmente del entorno del servidor. Al guardarla aquí, Administración pasará a gestionarla.",
    "statActiveUsers": "Usuarios activos",
    "statOpenTickets": "Tickets abiertos",
    "statPendingRegistrations": "Altas pendientes",
    "subtitle": "Altas de clientes, presupuestos, soporte y ajustes del portal.",
    "tabAudit": "Auditoría",
    "tabAssistantAnalytics": "Analítica Atlas",
    "tabBudgets": "Presupuestos",
    "tabRegistrations": "Altas",
    "tabSettings": "Ajustes",
    "tabNotifications": "Notificaciones",
    "tabEmail": "Correo",
    "tabTickets": "Soporte",
    "tabUsers": "Usuarios",
    "tabReleases": "Novedades",
    "releasesTitle": "Novedades de la plataforma",
    "releasesDescription": "Cambios publicados para Comerciales y Gestores.",
    "releaseNew": "Nuevo release",
    "releasesEmpty": "Todavía no hay releases",
    "releasesEmptyText": "Las novedades publicadas aparecerán aquí.",
    "releaseStatus": {
      "draft": "Borrador",
      "published": "Publicado"
    },
    "releaseLinkedCount": "{{count}} solicitudes vinculadas",
    "releaseIncludesYours": "Incluye una solicitud tuya",
    "releaseEdit": "Editar release",
    "releaseVersion": "Versión",
    "releaseTitle": "Título",
    "releaseSummary": "Resumen",
    "releaseChanges": "Cambios",
    "releaseChangesHelp": "Escribe un cambio por línea.",
    "releaseLinkedRequests": "Solicitudes vinculadas",
    "releaseLinkedRequestsHelp": "Al publicar, las solicitudes vinculadas quedarán completadas.",
    "releaseSaved": "Release guardada.",
    "platformRequestTitle": "Proponer una mejora",
    "platformRequestAction": "Proponer mejora o modificación",
    "platformRequestDescription": "Cuéntanos qué debería añadirse o mejorarse en la plataforma.",
    "platformRequestSubject": "Título de la solicitud",
    "platformRequestDetails": "Descripción",
    "platformRequestSend": "Enviar solicitud",
    "platformRequestSent": "Solicitud enviada.",
    "platformRequestsAll": "Solicitudes de empleados",
    "platformRequestsMine": "Mis solicitudes",
    "platformRequestsAllText": "Revisa, planifica y vincula las propuestas con un release.",
    "platformRequestsMineText": "Consulta el estado y en qué versión se ha incluido cada propuesta.",
    "platformRequestsEmpty": "No hay solicitudes",
    "platformRequestsEmptyText": "Las nuevas propuestas aparecerán aquí.",
    "platformRequestStatus": {
      "new": "Nueva",
      "under_review": "En revisión",
      "planned": "Planificada",
      "declined": "Descartada",
      "completed": "Completada"
    },
    "platformRequestAdminNote": "Nota del administrador",
    "platformRequestIncluded": "Incluida en v{{version}}",
    "platformRequestReview": "Revisar solicitud",
    "platformRequestSaved": "Solicitud actualizada.",
    "usersTitle": "Gestión de usuarios",
    "usersHint": "Administra el acceso y la vinculación comercial de las cuentas del portal.",
    "usersCount": "{{count}} usuarios",
    "searchUsers": "Buscar usuarios",
    "user": "Usuario",
    "userRole": "Rol",
    "userRole_client": "Cliente",
    "userRole_commercial": "Comercial",
    "userRole_manager": "Gestor",
    "userRole_admin": "Administrador",
    "rolesAdminOnly": "Solo un administrador puede cambiar el rol.",
    "emailBroadcastTitle": "Enviar un correo general",
    "emailBroadcastHint": "Envía un mismo mensaje por copia oculta a todos los usuarios activos del rol elegido.",
    "emailAudienceRole": "Destinatarios",
    "emailSubject": "Asunto",
    "emailBody": "Mensaje",
    "addAttachments": "Añadir adjuntos",
    "noAttachments": "Sin adjuntos · máximo 5 archivos de 10 MB",
    "sendEmailNow": "Enviar correo",
    "sendingEmail": "Enviando…",
    "emailBroadcastSent": "Correo enviado a {{count}} destinatarios con {{attachments}} adjuntos.",
    "userStatus_pending": "Pendiente",
    "userStatus_active": "Activo",
    "userStatus_blocked": "Bloqueado",
    "customerCode": "Código de cliente",
    "generatedBudgets": "Solicitudes y presupuestos",
    "viewUserRequests": "Ver todas las solicitudes de este usuario",
    "userRequestsTitle": "Solicitudes de {{name}}",
    "userRequestsHint": "Incluye borradores, lecturas, revisiones y presupuestos ya generados. Puedes continuar, reanalizar y gestionar las solicitudes del usuario.",
    "userRequestsEmpty": "Este usuario todavía no ha creado ninguna solicitud.",
    "userRequestItems": "{{count}} artículos",
    "userRequestCreated": "Creada",
    "userRequestFiles": "Archivos",
    "userRequestBudget": "Presupuesto",
    "userRequestBudgetPending": "Aún no generado",
    "userRequestMaterials": "Listado de materiales",
    "userRequestMaterialsPending": "El listado todavía no está disponible en esta fase.",
    "assistantAnalyticsRecentQuestions": "Preguntas recientes",
    "assistantAnalyticsRecentQuestionsHint": "Consultas realizadas al asistente, con la cuenta que las envió.",
    "assistantAnalyticsUnknownUser": "Usuario no disponible",
    "lastAccess": "Último acceso",
    "neverAccessed": "Nunca",
    "editUser": "Editar usuario",
    "adaQuoteCustomerCodeAdminHint": "Código de AdaQuote de esta empresa o sucursal. Se aplica a sus cuentas Cliente; otras sucursales pueden compartirlo sin verse modificadas.",
    "editCustomerCode": "Editar código de cliente",
    "editCustomerCodeFor": "Editar código de cliente de {{name}}",
    "staffCustomerCodeHint": "El administrador puede asignar un código propio a esta cuenta. Si no tiene uno, utiliza 0.",
    "staffPersonalCustomerCodeHint": "Código propio de este usuario para enviar y consultar presupuestos. No cambia el de su empresa ni el de otros usuarios. Si lo dejas vacío, se usará 0.",
    "personalCustomerCodeHint": "Código propio de este administrador para enviar y consultar presupuestos. No cambia el de otros usuarios. Si lo dejas vacío, se usará 0.",
    "userSaved": "Usuario actualizado.",
    "ticketClosed": "Cerrado",
    "ticketInProgress": "En curso",
    "ticketOpen": "Abierto",
    "ticketsEmpty": "No hay tickets",
    "ticketsEmptyText": "Las consultas de soporte de los clientes aparecerán aquí.",
    "title": "Administración",
    "withdraw": "Retirar la oferta",
    "withdrawDone": "Presupuesto retirado.",
    "withdrawText": "«{{ref}}» pasará a caducado y el cliente ya no podrá aceptarlo. Se le avisará.",
    "withdrawTitle": "¿Retirar este presupuesto?",
    "adaQuoteTitle": "Ada-quote",
    "adaQuoteHint": "Conexión directa opcional para sincronizar presupuestos. El stock y los PDF también disponen de su propia consulta mediante Atlas.",
    "adaQuoteBaseUrl": "Dirección de la API",
    "adaQuoteApiKey": "Clave de API",
    "adaQuoteApiKeyHint": "Se envía a Ada-quote para acreditar al portal.",
    "adaQuoteEnabled": "Conexión activa",
    "adaQuoteEnabledHint": "Apagada, se omite la sincronización directa con Ada-quote. No desactiva la conexión de Atlas.",
    "adaQuoteSaved": "Conexión guardada.",
    "adaQuoteTestOk": "Ada-quote responde correctamente.",
    "adaQuoteTestNoHealth": "Ada-quote responde y acepta la clave, aunque no tiene página de estado.",
    "adaQuoteTestFail": {
      "missingBaseUrl": "Falta la dirección de la API.",
      "missingApiKey": "Falta la clave de API.",
      "unauthorized": "Ada-quote rechaza la clave.",
      "badStatus": "Ada-quote responde, pero con error ({{status}}).",
      "timeout": "Ada-quote no ha contestado a tiempo.",
      "unreachable": "No se ha podido conectar con la dirección de Ada-quote."
    },
    "adaQuoteScope": "Cada cliente solo ve sus presupuestos: el portal usa el código de cliente de AdaQuote guardado en la empresa de la sesión, nunca uno enviado por el navegador.",
    "connectionChecking": "Comprobando…",
    "connectionKeyNotVerified": "Responde, pero no hemos podido comprobar la clave.",
    "modules": {
      "title": "Módulos",
      "checking": "Comprobando el estado de cada módulo…",
      "summary": "{{active}} de {{total}} activos",
      "withIssues": "{{count}} con incidencias",
      "refresh": "Comprobar ahora",
      "version": "Versión {{version}}",
      "versionUnknown": "Versión no disponible",
      "configure": "Configurar",
      "tools": "Herramientas",
      "serverSwitch": "Se activa en el servidor",
      "state": {
        "on": "Activo",
        "off": "Desactivado",
        "error": "Error",
        "warning": "Desactualizado",
        "checking": "Comprobando…"
      },
      "atlas": {
        "title": "Atlas · API de lectura",
        "text": "Lee los documentos de las solicitudes, identifica los productos y prepara los presupuestos."
      },
      "adaQuote": {
        "title": "Ada-quote",
        "text": "Precios, descuentos, stock y presupuestos en el ERP."
      },
      "customers": {
        "title": "Maestro de clientes",
        "text": "Clientes y direcciones de entrega de Ada para asignar cliente y pasar a pedido.",
        "detail": "{{count}} clientes · versión {{version}} · comprobado {{date}}",
        "stale": "Sin actualizar desde {{date}}",
        "unavailable": "Atlas no responde"
      },
      "catalog": {
        "title": "Catálogo de productos",
        "text": "Copia del Máster de productos que publica Atlas, para buscar y validar referencias.",
        "detail": "{{count}} productos · versión {{version}} · {{date}}"
      },
      "assistant": {
        "text": "Chat de ayuda de Atlas para el personal y los clientes."
      }
    },
    "notifConfig": {
      "pushTitle": "Configuración de los avisos",
      "pushHint": "Web Push y los canales por los que llegan los avisos del portal.",
      "emailTitle": "Configuración del correo",
      "emailHint": "Servidor de correo (SMTP) y avisos por correo electrónico.",
      "sender": "Remitente",
      "notConfigured": "Sin configurar"
    },
    "connection": {
      "connected": "Conectado",
      "error": "Error",
      "disconnected": "Desconectado"
    },
    "direccion": {
      "interna": "Esta dirección solo existe dentro de la red local. El portal la alcanza desde aquí, pero dejará de alcanzarla en cuanto se despliegue fuera. Para eso hace falta un túnel o una dirección pública.",
      "sinCifrar": "Dirección sin cifrar (http). La clave de API viaja en una cabecera, así que fuera de la red propia conviene usar https.",
      "malformada": "Esta dirección no parece válida. Debe empezar por https:// o http://."
    },
    "catalogSync": "Copiar catálogo",
    "catalogSyncing": "Copiando…",
    "catalogSynced": "Catálogo copiado: {{count}} artículos ({{deactivated}} retirados).",
    "catalogAlreadyCurrent": "La copia ya está al día: {{count}} artículos.",
    "approvedEmailUnavailable": "Cuenta aprobada. No se ha podido enviar el correo de aviso al cliente.",
    "requestSendToAtlas": "Enviar a Atlas",
    "requestSendConfirm": "Enviarás {{ref}}, con {{count}} líneas, a Atlas para crear el presupuesto en AdaQuote de {{name}}. Se usarán los datos y el código de cliente del propietario.",
    "requestReviewWithAtlas": "Revisar con Atlas",
    "requestDiscardSuggestion": "No añadir",
    "requestRecovered": "Listado recuperado de {{ref}}. Completa la revisión antes de enviar.",
    "requestAlreadySent": "El encargo ya está enviado a Atlas o tiene un presupuesto asociado.",
    "requestNeedsReview": "El listado debe terminar su revisión antes del envío.",
    "requestContinue": "Continuar solicitud",
    "requestOpen": "Abrir solicitud",
    "requestReanalyze": "Volver a analizar",
    "requestDelete": "Eliminar solicitud",
    "requestCancel": "Cancelar solicitud",
    "requestRestore": "Recuperar solicitud",
    "requestBackToUsers": "Volver a usuarios",
    "requestActingFor": "Gestionando la solicitud de {{name}} · {{company}}",
    "requestExistingOnly": "Continúa esta solicitud o vuelve a Administración para elegir otra.",
    "requestActionTitle_reanalyze": "Volver a analizar los documentos",
    "requestActionTitle_delete": "Eliminar solicitud",
    "requestActionTitle_cancel": "Cancelar solicitud",
    "requestActionConfirm_reanalyze": "¿Volver a analizar los documentos de {{ref}}, de {{name}}? Se revisará de nuevo el listado y habrá que confirmar los resultados antes del envío.",
    "requestActionConfirm_delete": "¿Eliminar definitivamente {{ref}}, de {{name}}, y sus archivos? Esta acción no se puede deshacer.",
    "requestActionConfirm_cancel": "¿Cancelar {{ref}}, de {{name}}? Después podrás recuperarla o eliminarla definitivamente desde Administración.",
    "requestBudgetReadOnly": "Consulta administrativa del presupuesto. La aceptación y el rechazo corresponden al cliente.",
    "userRole_orders": "Pedidos",
    "deleteUserDescription": "Se retirará el acceso y el usuario desaparecerá de esta lista. Se conservarán sus solicitudes, presupuestos y auditoría.",
    "passwordChangePending": "Cambio de contraseña pendiente",
    "forcePasswordResetDescription": "Se enviará un correo con un enlace de una hora para escribir la contraseña nueva y repetirla. Tras enviarlo, sus sesiones se cerrarán y deberá cambiar la contraseña para volver a acceder.",
    "ownPasswordAction": "Cambia tu contraseña desde tu perfil",
    "deletingUser": "Borrando…",
    "sendingPasswordReset": "Enviando…",
    "userDeleted": "Usuario borrado. Se han conservado sus solicitudes y presupuestos.",
    "deleteUser": "Borrar usuario",
    "sendPasswordReset": "Enviar correo",
    "cannotDeleteSelf": "No puedes borrar tu propia cuenta",
    "forcePasswordResetFor": "Forzar cambio de contraseña de {{name}}",
    "passwordResetSent": "Correo enviado. El usuario debe cambiar su contraseña para volver a acceder.",
    "forcePasswordReset": "Forzar cambio de contraseña",
    "deleteUserFor": "Borrar a {{name}}",
    "budgetCreatedBy": "Creado por",
    "budgetCreatedAt": "Fecha de creación",
    "budgetsPerPage": "Presupuestos por página",
    "budgetPageRange": "{{from}}–{{to}} de {{count}}"
  },
  "assistant": {
    "title": "Asistente Atlas",
    "placeholder": "Escribe tu consulta…",
    "send": "Enviar",
    "thinking": "Atlas está escribiendo…",
    "newConversation": "Nueva conversación",
    "resetConfirmTitle": "¿Empezar una conversación nueva?",
    "resetConfirmText": "Se abrirá un chat en blanco. Cada conversación y su historial completo se eliminan a las 24 horas de su creación, aunque sigas escribiendo.",
    "emptyTitle": "¿En qué puedo ayudarte?",
    "emptyText": "Consúltame productos Ekselans: características, fichas técnicas, manuales y disponibilidad.",
    "suggestion1": "¿Qué puntos de acceso con WiFi 6 tenéis?",
    "suggestion2": "Dame la ficha técnica del AX 3000",
    "suggestion3": "¿Cómo solicito una ampliación de garantía?",
    "you": "Tú",
    "assistantName": "Atlas",
    "disclaimer": "Atlas puede equivocarse. Revisa siempre las referencias antes de confirmar un pedido.",
    "unavailableTitle": "El asistente no está disponible",
    "unavailableText": "No hemos podido conectar con Atlas. Inténtalo de nuevo en unos minutos.",
    "drawingDiagram": "Dibujando el esquema…",
    "downloadDiagram": "Descargar el esquema en PNG",
    "diagramFileName": "esquema-atlas",
    "enlargeImage": "Ampliar la imagen",
    "enlargeDiagram": "Ampliar el esquema",
    "stop": "Detener la respuesta",
    "stopped": "Respuesta detenida",
    "copyAnswer": "Copiar la respuesta",
    "jumpToLatest": "Ir al último mensaje",
    "threadLabel": "Conversación con Atlas",
    "charsLeft_one": "Queda {{count}} carácter",
    "charsLeft_other": "Quedan {{count}} caracteres",
    "charLimit": "Se ha alcanzado el máximo de {{max}} caracteres.",
    "resetConfirmAction": "Empezar de nuevo",
    "sendFailed": "No se ha podido enviar el mensaje.",
    "composerHint": "Intro para enviar · Mayús+Intro para salto de línea",
    "conversations": "Conversaciones",
    "showConversations": "Ver las conversaciones",
    "hideConversations": "Ocultar las conversaciones",
    "untitled": "Conversación nueva",
    "newChat": "Conversación nueva",
    "noConversations": "Todavía no has hablado con Atlas",
    "renameTitle": "Cambiar el nombre de la conversación",
    "renameLabel": "Nombre",
    "removeTitle": "¿Eliminar esta conversación?",
    "removeText": "La conversación y su transcripción se eliminarán definitivamente. Esta acción no se puede deshacer.",
    "remove": "Eliminar",
    "conversationOptions": "Opciones de la conversación",
    "olderThanWeek": "Anteriores",
    "thisWeek": "Esta semana",
    "reasoning": "Atlas está pensando…",
    "reasoningSteps": {
      "searching": "Buscando información",
      "consulting": "Consultando la documentación",
      "comparing": "Comparando opciones",
      "verifying": "Verificando los datos",
      "identifying": "Identificando el producto",
      "clarifying": "Aclarando los requisitos",
      "preparing": "Preparando la respuesta",
      "reviewing": "Analizando la consulta",
      "working": "Procesando la consulta"
    }
  },
  "assistantWidget": {
    "needHelp": "¿Necesitas ayuda?",
    "productQuestion": "¿Alguna duda con algún producto?",
    "open": "Hablar con la mascota Atlas",
    "title": "Atlas",
    "status": "Tu asistente de productos",
    "greeting": "¡Hola! Soy Atlas. Pregúntame por un producto, una equivalencia o tu próximo presupuesto.",
    "expand": "Abrir el Asistente completo",
    "placeholder": "Escribe a Atlas…",
    "send": "Enviar mensaje",
    "thinking": "Atlas está pensando…"
  },
  "auth": {
    "signInTitle": "Accede a tu portal",
    "signInSubtitle": "Consulta tus solicitudes y presupuestos en un solo lugar.",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "showPassword": "Mostrar contraseña",
    "hidePassword": "Ocultar contraseña",
    "rememberMe": "Recordarme",
    "forgotPassword": "¿Has olvidado tu contraseña?",
    "signIn": "Iniciar sesión",
    "signingIn": "Accediendo…",
    "secureAccess": "Acceso seguro para clientes Adaltra",
    "noAccount": "¿Todavía no tienes cuenta?",
    "createAccount": "Crear una cuenta",
    "haveAccount": "¿Ya tienes cuenta?",
    "backToSignIn": "Volver a iniciar sesión",
    "orContinueWith": "o continúa con",
    "continueWithGoogle": "Continuar con Google",
    "continueWithMicrosoft": "Continuar con Outlook",
    "googleShort": "Google",
    "microsoftShort": "Outlook",
    "providerNotConfigured": "Este acceso todavía no está configurado. Añade las credenciales en el servidor para activarlo.",
    "heroTitle": "De tu lista de materiales a un presupuesto, sin complicaciones.",
    "heroSubtitle": "Fotografía, revisa y confirma. Tú mantienes siempre el control.",
    "heroTitleRegister": "Empieza a solicitar presupuestos de una forma más sencilla.",
    "heroSubtitleRegister": "Crea tu acceso al Portal del cliente y centraliza todas las solicitudes de tu empresa.",
    "trustDocuments": "Tus documentos, protegidos",
    "trustReview": "Revisión humana antes de enviar",
    "trustSecureSignUp": "Alta segura y protegida",
    "trustTracking": "Seguimiento desde el primer día",
    "registerTitle": "Crea tu acceso",
    "registerSubtitle": "Registra los datos principales de tu empresa para empezar a utilizar el portal.",
    "fullName": "Nombre completo",
    "phone": "Teléfono",
    "companyName": "Empresa",
    "taxId": "CIF / NIF",
    "createAccountAction": "Crear cuenta",
    "registeredTitle": "Ya tenemos tus datos",
    "registrationReceived": "El equipo de Adaltra validará los datos de la empresa y te enviará el acceso al correo indicado.",
    "forgotTitle": "Recupera tu contraseña",
    "forgotSubtitle": "Introduce tu correo y te enviaremos un enlace para crear una contraseña nueva.",
    "sendLink": "Enviar enlace",
    "resetEmailSent": "Si el correo corresponde a una cuenta registrada, recibirás un enlace para restablecer la contraseña.",
    "resetTitle": "Crea una contraseña nueva",
    "newPassword": "Contraseña nueva",
    "repeatPassword": "Repite la contraseña",
    "passwordUpdated": "Contraseña actualizada. Ya puedes iniciar sesión.",
    "passwordHint": "Al menos 10 caracteres, combinando letras y números.",
    "currentPassword": "Contraseña actual",
    "changePassword": "Cambiar contraseña",
    "setPassword": "Establecer contraseña",
    "heroAccent": "sin complicaciones.",
    "heroAccentRegister": "más sencilla.",
    "trustDevice": "Dispositivo de confianza",
    "trustDeviceHint": "No pedir el código en este navegador durante 30 días."
  },
  "authProvider": {
    "google": "Alta con Google",
    "microsoft": "Alta con Outlook",
    "password": "Alta por formulario"
  },
  "brand": {
    "name": "Atlas",
    "portal": "Portal del cliente",
    "poweredBy": "Impulsado por",
    "version": "Versión {{version}}",
    "company": "Adaltra"
  },
  "budget": {
    "period": "Fecha de emisión",
    "dateFrom": "Desde",
    "dateTo": "Hasta",
    "invalidDates": "La fecha Hasta debe ser igual o posterior a Desde.",
    "paginationSummary": "{{from}}–{{to}} de {{total}} presupuestos",
    "periods": {
      "all": "Todas las fechas",
      "today": "Hoy",
      "week": "Últimos 7 días",
      "month": "Últimos 30 días",
      "quarter": "Últimos 90 días",
      "year": "Este año",
      "custom": "Intervalo personalizado"
    },
    "listTitle": "Presupuestos",
    "listSubtitle": "Consulta y descarga tus pedidos aprobados.",
    "refresh": "Actualizar",
    "refreshing": "Actualizando…",
    "searchPlaceholder": "Buscar por referencia o proyecto",
    "emptyTitle": "Todavía no hay presupuestos",
    "emptyText": "Aquí aparecerán los presupuestos cuando hayas aceptado el pedido.",
    "validUntil": "Válido hasta",
    "issuedOn": "Emitido el",
    "detailTitle": "Detalle del presupuesto",
    "linkedRequest": "Solicitud vinculada",
    "downloadPdf": "Descargar PDF",
    "approve": "Aprobar presupuesto",
    "reject": "Rechazar",
    "approveDialogTitle": "¿Aprobar el presupuesto?",
    "approveDialogText": "Al aprobarlo, Adaltra iniciará la preparación del pedido.",
    "rejectDialogTitle": "¿Rechazar el presupuesto?",
    "rejectDialogText": "Cuéntanos el motivo para que podamos preparar una propuesta mejor.",
    "rejectReason": "Motivo del rechazo",
    "approvedMessage": "Presupuesto aprobado",
    "rejectedMessage": "Presupuesto rechazado",
    "pendingEyebrow": "PENDIENTE DE APROBACIÓN",
    "pendingTitle": "Revisa y aprueba tu presupuesto",
    "pendingText": "Comprueba el importe y las condiciones antes de confirmar la propuesta.",
    "draftEyebrow": "Todavía no es definitivo",
    "draftTitle": "Tu presupuesto está en revisión",
    "draftText": "Ya está preparado y lo está revisando un comercial de Adaltra. Puedes verlo mientras tanto, pero las cifras aún pueden cambiar: podrás aceptarlo o rechazarlo cuando te lo envíe.",
    "approvedEyebrow": "PRESUPUESTO APROBADO",
    "approvedTitle": "Presupuesto aprobado",
    "approvedText": "La propuesta ha sido aprobada y puedes descargar el documento final.",
    "orderedEyebrow": "PASADO A PEDIDO",
    "orderedTitle": "Pedido {{order}} creado",
    "orderedText": "El presupuesto se ha ganado y el pedido ya está procesado en MTR.",
    "sentEyebrow": "PRESUPUESTO ENVIADO",
    "sentTitle": "Tu presupuesto está listo",
    "sentText": "Revisa el resumen y descarga el documento completo en PDF.",
    "expiredEyebrow": "PRESUPUESTO CADUCADO",
    "expiredTitle": "Este presupuesto ha caducado",
    "expiredText": "Solicita una actualización para revisar precios y disponibilidad.",
    "rejectedEyebrow": "PRESUPUESTO RECHAZADO",
    "rejectedTitle": "Has rechazado este presupuesto",
    "rejectedText": "Puedes solicitar una propuesta nueva cuando lo necesites.",
    "commercialRejectedEyebrow": "PRESUPUESTO NO APROBADO",
    "commercialRejectedTitle": "No ha superado la revisión comercial",
    "commercialRejectedText": "Puedes solicitar una nueva propuesta.",
    "unitPrice": "Precio unitario",
    "pricePending": "Consultar",
    "partialTotal_one": "El total es parcial: falta fijar el precio de 1 producto.",
    "partialTotal_other": "El total es parcial: falta fijar el precio de {{count}} productos.",
    "discount": "Descuento",
    "lineTotal": "Importe",
    "requestChanges": "Solicitar cambios",
    "requestChangesDialogTitle": "¿Qué hay que corregir?",
    "requestChangesDialogText": "El presupuesto vuelve a Adaltra con tu nota y sigue vivo: no lo estás rechazando. Recibirás una propuesta corregida.",
    "requestChangesLabel": "Qué hay que revisar",
    "requestChangesHint": "Indica la línea, la cantidad o la referencia que no cuadra. Cuanto más concreto, antes vuelve arreglado.",
    "changesSentMessage": "Hemos enviado tu petición a Adaltra",
    "changesEyebrow": "CAMBIOS PEDIDOS",
    "changesTitle": "Adaltra está revisando tu petición",
    "changesText": "Recibirás una propuesta corregida. Mientras tanto puedes seguir aceptándolo o rechazándolo tal cual está.",
    "changesNoteLabel": "Lo que pediste corregir",
    "viewPdf": "Ver el PDF",
    "hidePdf": "Ocultar el PDF",
    "openPdfInTab": "Abrir en una pestaña",
    "pdfNotReady": "El PDF todavía no está disponible",
    "pdfNotReadyText": "Adaltra lo adjuntará en cuanto esté firmado. El detalle de líneas de abajo ya es el definitivo.",
    "pdfFallback": "Tu navegador no puede mostrar el PDF aquí. Ábrelo en una pestaña o descárgalo.",
    "revision": "Revisión {{count}}",
    "expiredOn": "Caducó el {{date}}",
    "expiresToday": "Caduca hoy",
    "expiresIn_one": "Caduca en {{count}} día",
    "expiresIn_other": "Caduca en {{count}} días",
    "requestAgain": "Pedir uno nuevo",
    "decide": "Decidir"
  },
  "budgetStatus": {
    "draft": "En revisión del comercial",
    "sent": "Enviado",
    "pending_approval": "Pendiente de aprobación",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "expired": "Caducado",
    "changes_requested": "Cambios pedidos",
    "ordered": "Pedido creado"
  },
  "common": {
    "openInNewTab": "Abrir en otra pestaña",
    "continue": "Continuar",
    "back": "Volver",
    "cancel": "Cancelar",
    "save": "Guardar",
    "saveChanges": "Guardar cambios",
    "saved": "Cambios guardados",
    "delete": "Eliminar",
    "edit": "Editar",
    "add": "Añadir",
    "search": "Buscar",
    "filter": "Filtrar",
    "all": "Todos",
    "close": "Cerrar",
    "confirm": "Confirmar",
    "download": "Descargar",
    "retry": "Intentar de nuevo",
    "loadMore": "Cargar más",
    "loading": "Cargando…",
    "saving": "Guardando…",
    "sending": "Enviando…",
    "optional": "Opcional",
    "required": "Obligatorio",
    "yes": "Sí",
    "no": "No",
    "of": "de",
    "page": "Página",
    "quantity": "Cantidad",
    "unit": "Unidad",
    "description": "Descripción",
    "code": "Código",
    "reference": "Referencia",
    "brandLabel": "Marca",
    "date": "Fecha",
    "status": "Estado",
    "total": "Total",
    "subtotal": "Subtotal",
    "vat": "IVA",
    "project": "Proyecto",
    "actions": "Acciones",
    "noResults": "No hay resultados",
    "seeAll": "Ver todo",
    "seeDetail": "Ver detalle",
    "preview": "Vista previa",
    "rotate": "Girar",
    "zoom": "Ampliar",
    "empty": "Sin datos todavía",
    "copy": "Copiar",
    "copied": "Copiado",
    "dismiss": "Descartar",
    "rename": "Cambiar el nombre",
    "today": "Hoy",
    "yesterday": "Ayer",
    "showMore": "Ver más",
    "showLess": "Ver menos",
    "view": "Ver",
    "catalogName": "catálogo",
    "brand": "Marca"
  },
  "dashboard": {
    "attentionAllDone": "Todo al día",
    "attentionAllDoneText": "No hay nada esperando por tu parte. Crea una solicitud cuando la necesites.",
    "attentionNextStep": "Siguiente paso",
    "attentionTitle": "Requiere tu atención",
    "createFirst": "Crear la primera solicitud",
    "emptyBudgets": "Aquí aparecerán tus presupuestos cuando estén listos.",
    "emptyRequests": "Todavía no has creado ninguna solicitud.",
    "greeting": "{{salutation}}, {{name}}",
    "greetings": {
      "morning": "Buenos días",
      "afternoon": "Buenas tardes",
      "night": "Buenas noches"
    },
    "groupDecide": "Listos para tu decisión",
    "groupDecideText": "Acéptalos, pide cambios o recházalos.",
    "groupExpired": "Caducados",
    "groupExpiredText": "Ya no se pueden aceptar. Pide uno nuevo si aún te interesa.",
    "groupReview": "Pendiente de tu revisión",
    "reviewReadingText": "La lectura del documento está pendiente de tu confirmación.",
    "reviewProductsText": "Falta revisar el listado y resolver los productos pendientes.",
    "reviewRecommendationsText": "Quedan recomendaciones de Atlas por revisar.",
    "reviewConfirmationText": "El listado está revisado. Falta confirmar y enviar la solicitud.",
    "groupReviewText": "Atlas ya ha leído el listado. Compruébalo y corrige lo que haga falta.",
    "readingErrorText": "No se ha podido leer el archivo. Abre la solicitud para reintentar el análisis o cambiar los archivos.",
    "groupSubmitted": "Enviadas a Atlas",
    "groupSubmittedText": "Estamos preparando el presupuesto.",
    "inProgressText": "Estamos trabajando en ello. No hace falta que hagas nada.",
    "inProgressViewAll": "Ver las {{count}} solicitudes en curso",
    "inProgressTitle": "En curso",
    "itemsAndLines": "{{count}} líneas",
    "newRequestCta": "Nueva solicitud de presupuesto",
    "newRequestHint": "Fotografía tu lista de materiales o súbela como archivo.",
    "recentBudgets": "Últimos presupuestos",
    "recentEmpty": "Aquí aparecerán tus solicitudes y presupuestos a medida que se vayan cerrando.",
    "recentRequests": "Últimas solicitudes",
    "recentTitle": "Tu actividad reciente",
    "reviewCta": "Revisar solicitud",
    "seeBudgets": "Ver todos los presupuestos",
    "seeRequests": "Ver todas las solicitudes",
    "statApprovedBudgets": "Presupuestos aprobados",
    "statApprovedTotal": "Importe aprobado",
    "statDecision": "Esperan tu decisión",
    "statReview": "Esperan tu revisión",
    "statTotalBudgets": "Presupuestos totales",
    "statOpenRequests": "Solicitudes en curso",
    "statPendingBudgets": "Presupuestos pendientes",
    "subtitle": "Este es el estado de tus solicitudes y presupuestos.",
    "summaryCount": "{{count}} presupuestos",
    "summaryTitle": "Aprobado hasta hoy",
    "toDecide": "Listo para tu decisión",
    "toReview": "Pendiente de tu revisión",
    "validatedQuoteText": "El presupuesto está validado y disponible para consultar o descargar antes de aceptarlo.",
    "viewValidatedQuote": "Ver presupuesto",
    "attentionEmpty": "No tienes solicitudes ni presupuestos pendientes de revisar.",
    "inProgressEmpty": "Aquí verás las solicitudes mientras Atlas prepara tus presupuestos.",
    "inProgressOpen": "Ver solicitudes en curso"
  },
  "valuation": {
    "informational": "Precios calculados por Ada-quote para el cliente y destino seleccionados. La fecha de entrega y el número de pedido siguen guardados en Atlas; esta consulta no los aplica.",
    "basePrice": "Precio base",
    "unitPriceNet": "Precio neto",
    "literalDiscounts": "D1, D2 y D3 son los descuentos literales recibidos, en su orden. Su tipo y base de aplicación no están confirmados; se muestran sin añadir porcentajes ni recalcularlos.",
    "queriedAt": "Consultado (hora de España)",
    "informationalWaiting": "Precios recibidos. La confirmación económica sigue pendiente.",
    "receivedBlocked": "Atlas ha guardado los datos del pedido. La valoración económica está pendiente de Ada-quote.",
    "noDiscounts": "Sin descuentos",
    "title": "Valoración del pedido",
    "subtitle": "Revisa los precios y descuentos aplicados a este cliente antes de confirmar.",
    "request": "Obtener valoración",
    "refresh": "Actualizar valoración",
    "pending": "Ada-quote está preparando la valoración…",
    "notRequested": "Solicita la valoración para recibir las condiciones económicas de este cliente. Este paso no confirma ningún pedido.",
    "stale": "La valoración anterior ya no está vigente. Revisa el cliente, la dirección y las cantidades antes de volver a consultar.",
    "expired": "La valoración ha caducado. Actualízala para revisar los importes vigentes.",
    "linesTitle": "Productos valorados",
    "article": "Artículo",
    "quantity": "Cantidad",
    "unitPrice": "Precio unitario",
    "discounts": "Descuentos",
    "netUnitPrice": "Precio con descuento",
    "lineTotal": "Importe",
    "sourceNotice": "Los precios, descuentos e importes se muestran tal como los facilita Ada-quote.",
    "addedByProvider": "Añadida por Ada-quote (no está en el listado)",
    "addedWarning": "Advertencia",
    "addedWillRemove": "Se quitará del pedido.",
    "addedNotesHint": "La decisión se envía a Ada-quote en las notas del presupuesto.",
    "addedTitle": "Ada-quote ha añadido productos al pedido",
    "addedIntro": "Al valorar, Ada-quote ha añadido productos que no estaban en el listado. Decide si se mantienen en el pedido y, si quieres, indica su precio.",
    "addedKeep": "Mantener",
    "addedRemove": "Quitar",
    "addedPrice": "Precio por unidad (€)",
    "addedPriceHelp": "Vacío: se mantiene el precio de Ada-quote ({{price}}).",
    "addedAdaPrice": "Precio de Ada-quote: {{price}}",
    "addedSave": "Guardar decisión",
    "addedLater": "Más tarde",
    "addedChange": "Cambiar",
    "addedRemoved": "Quitada del pedido",
    "addedPriceChanged": "Precio indicado por Pedidos",
    "addedPending": "Decide si mantienes los productos que ha añadido Ada-quote antes de continuar.",
    "addedAdjusted": "Importes ajustados con tu decisión sobre los productos añadidos por Ada-quote. La decisión se envía a Ada-quote en las notas del pedido.",
    "addedPriceInvalid": "Indica un precio válido (por ejemplo, 25 o 25,50).",
    "totalsTitle": "Resumen económico",
    "subtotal": "Importe bruto",
    "discount": "Descuento total",
    "netSubtotal": "Subtotal neto",
    "tax": "Impuestos",
    "total": "Total",
    "quoteReference": "Presupuesto",
    "continue": "Revisado, continuar a Confirmación",
    "ready": "Valoración recibida. Revisa los importes antes de continuar.",
    "waiting": "La valoración debe estar disponible y revisada antes de confirmar."
  },
  "errors": {
    "valuationUncertain": "No se ha podido confirmar el resultado de la consulta. Se conserva el intento; no se reenviará automáticamente.",
    "valuationIntegrationPending": "La valoración económica está pendiente de la integración con Ada-quote. Todavía no hay precios disponibles para este pedido.",
    "valuationUnavailable": "No se puede consultar la valoración en este momento. Inténtalo de nuevo.",
    "valuationInvalid": "La valoración recibida no corresponde al listado o no contiene datos económicos válidos.",
    "valuationChanged": "La valoración o el listado han cambiado. Actualiza y revisa los importes de nuevo.",
    "valuationAdditionalLinesPending": "Decide si mantienes los productos que ha añadido Ada-quote antes de continuar.",
    "valuationNotApplicable": "Este paso solo está disponible para solicitudes con cliente asignado.",
    "valuationReviewRequired": "Obtén y revisa una valoración vigente antes de confirmar el pedido.",
    "requesterEmailUnavailable": "No se puede acreditar el correo del usuario que solicita el envío. Revisa su cuenta antes de continuar.",
    "customerAssignmentNotEnabled": "Los datos del pedido están guardados. El envío comercial permanece pendiente de la integración con Ada-quote.",
    "customerAssignmentUnavailable": "La asignación de clientes todavía no está habilitada en este entorno.",
    "customerAssignmentChanged": "Los datos del cliente han cambiado. Busca y selecciona de nuevo el cliente y su dirección para guardar los cambios.",
    "customerAssignmentAddressInvalid": "La dirección seleccionada no pertenece a este cliente o ya no está disponible.",
    "deliveryDateInPast": "La fecha de entrega no puede ser anterior a hoy.",
    "customerAssignmentIncomplete": "Selecciona un cliente y su dirección de entrega antes de guardar los datos del pedido.",
    "customerAssignmentRequired": "Elige el cliente y su dirección de entrega para crear la solicitud.",
    "customerDirectoryUnavailable": "No se puede consultar el maestro de clientes de Atlas.",
    "customerDirectoryChanged": "El maestro de clientes ha cambiado. Vuelve a seleccionar el cliente y la dirección para guardar los cambios.",
    "customerDirectoryNotFound": "Atlas no encuentra el cliente o la ruta de consulta.",
    "customerDirectoryInvalid": "Atlas ha devuelto una respuesta de clientes no válida.",
    "atlasTestUnavailable": "Atlas Test no está disponible o su conexión ha cambiado. No se utilizará otra API automáticamente.",
    "atlasTestIdentity": "El servidor no acredita la identidad de Atlas Test. Comprueba su configuración antes de analizar.",
    "atlasTestFormatUnsupported": "Atlas Test todavía no acredita soporte para todos los formatos de esta solicitud.",
    "atlasTestCommercialDisabled": "Esta solicitud pertenece a Atlas Test y no puede enviar presupuestos ni pedidos.",
    "installationVerificationRequired": "Atlas debe verificar el listado actual antes de confirmar la solicitud.",
    "installationInvalidResponse": "Atlas ha devuelto una propuesta que no se puede validar. No se han enviado materiales.",
    "installationUnavailable": "La planificación de instalaciones todavía no está disponible en la conexión de Atlas. La descripción queda guardada.",
    "installationFailed": "Atlas no ha podido completar esta operación. Puedes volver a intentarlo sin enviar el presupuesto.",
    "installationChanged": "La solicitud o la revisión de Atlas ha cambiado. Actualiza la pantalla para continuar con la versión vigente.",
    "installationRequiresEmptyDraft": "Este método necesita una solicitud sin documentos ni materiales de otro método. Conserva esta solicitud y crea una nueva para describir la instalación.",
    "installationCatalogChanged": "Un producto o su unidad ya no coincide con el catálogo vigente. Revisa su selección antes de continuar.",
    "identityOptionsChanged": "Atlas ha actualizado las alternativas. Revisa las opciones actuales y vuelve a elegir.",
    "identitySelectionRequired": "Selecciona una alternativa de Atlas o indica que ninguna coincide.",
    "catalogProductRequired": "Elige un producto del catálogo para sustituir la sugerencia de Atlas.",
    "mandatoryDependenciesInvalid": "No se han aplicado las licencias porque la respuesta no es válida o la propuesta ha cambiado. Vuelve a analizar.",
    "pendingUnits": "Hay unidades pendientes de confirmar.",
    "pendingQuantities": "Hay cantidades pendientes. Revísalas antes de continuar con el presupuesto.",
    "unitProvenanceProtected": "Estas líneas conservan unidades del documento original. Edítalas individualmente; no se puede reemplazar todo el listado en modo manual.",
    "adaQuoteCustomerDataMissing": "Atlas necesita completar los datos del cliente antes de enviar a AdaQuote.",
    "submissionRetryUnsafe": "No se puede reenviar sin confirmar que AdaQuote aún no ha recibido el encargo. Actualiza el estado.",
    "submissionChecking": "Se está comprobando el resultado del reenvío. Actualiza el estado antes de volver a intentarlo.",
    "accountBlocked": "Tu cuenta no está activa. Contacta con Adaltra.",
    "accountPending": "Tu cuenta está pendiente de validación por Adaltra. Te avisaremos por correo.",
    "assistantDisabled": "El asistente está desactivado en este entorno.",
    "assistantFailed": "El asistente no ha podido responder. Inténtalo de nuevo.",
    "assistantSessionLost": "La conversación ya no está disponible.",
    "assistantTimeout": "El asistente ha tardado demasiado en responder.",
    "assistantUnavailable": "No hemos podido conectar con el asistente.",
    "badRequest": "La solicitud no es válida.",
    "badSignature": "La firma no es válida.",
    "budgetExpired": "El presupuesto ha caducado y no se puede aprobar.",
    "budgetNotExtendable": "Este presupuesto ya no admite prórroga.",
    "budgetNotFound": "No hemos encontrado el presupuesto.",
    "budgetNotRemindable": "Este presupuesto no está esperando una decisión.",
    "companyEditForbidden": "Solo el gestor de la cuenta puede modificar estos datos.",
    "companyNotFound": "No hemos encontrado la empresa.",
    "conflict": "La operación no se puede completar en este momento.",
    "conversationNotFound": "Esa conversación ya no está disponible.",
    "currentPasswordInvalid": "La contraseña actual no es correcta.",
    "documentNotReady": "El documento todavía no está disponible.",
    "duplicate": "Ese registro ya existe.",
    "emailAlreadyRegistered": "Ese correo ya está registrado.",
    "fileNotFound": "No hemos encontrado el archivo.",
    "fileTooLarge": "El archivo supera el tamaño máximo permitido.",
    "documentInvalid": "Uno de los archivos está dañado o no es del tipo que indica su extensión, y Atlas no puede leerlo. Ábrelo y guárdalo de nuevo (o expórtalo otra vez a PDF/Excel) y vuelve a subirlo.",
    "documentUnsupported": "Atlas no puede leer uno de los archivos por su tipo. Súbelo como PDF, Excel (XLSX/XLS), CSV o imagen.",
    "documentEmpty": "Uno de los archivos está vacío. Comprueba el archivo y vuelve a subirlo.",
    "forbidden": "No tienes permiso para realizar esta acción.",
    "genericText": "Hemos registrado el problema. Puedes volver a intentarlo.",
    "releaseNotFound": "No hemos encontrado el release.",
    "platformRequestNotFound": "No hemos encontrado la solicitud de mejora.",
    "genericTitle": "Algo no ha ido bien",
    "hermesDisabled": "La integración con Atlas está desactivada.",
    "hermesIncomplete": "Antes de activarla, completa la dirección y la clave de API.",
    "smtpIncomplete": "Antes de activar el correo, configura una URL SMTP o un servidor.",
    "smtpNotConfigured": "El servicio SMTP no está configurado o está desactivado.",
    "emailAudienceEmpty": "No hay usuarios activos con el rol seleccionado.",
    "pushIncomplete": "Antes de activar las notificaciones push, configura las claves VAPID y el contacto del servicio.",
    "hermesNotReady": "La integración con Atlas no está configurada.",
    "hermesRejected": "Atlas ha rechazado el encargo.",
    "hermesRequestRefAlreadySubmitted": "Este número ya se utilizó para otra solicitud en AdaQuote. Tu listado está guardado y necesita un número nuevo para poder enviarse.",
    "hermesRequestRefConflict": "Atlas ya tiene otro listado vinculado a este número de solicitud. Tus materiales están guardados; contacta con Adaltra para revisar el envío.",
    "recognitionUpdatedConcurrently": "La solicitud se ha actualizado desde otra sesión. Cierra este formulario y recarga la página antes de continuar.",
    "documentReviewChanged": "La revisión o el catálogo de Atlas han cambiado. Recarga la solicitud y comprueba el listado antes de continuar.",
    "documentReviewRejected": "Atlas no ha podido aceptar la confirmación del listado. Tus productos se conservan. El rechazo requiere revisión de la integración.",
    "hermesTimeout": "Atlas no ha contestado a tiempo.",
    "hermesUnreachable": "No se ha podido conectar con Atlas.",
    "invalidCredentials": "El correo o la contraseña no son correctos.",
    "invalidEmail": "El correo electrónico no es válido.",
    "invalidIdentifier": "El identificador no es válido.",
    "invalidProductReference": "La referencia del producto no es válida.",
    "invalidQuantity": "La cantidad no es válida.",
    "invalidTransition": "Esta acción no es posible en el estado actual.",
    "lineNotFound": "No hemos encontrado la línea.",
    "includedComponentReadOnly": "Este componente está incluido. Modifica el rack padre para actualizar su cantidad.",
    "includedComponentUnbound": "Hay una línea ACC SRP sin un rack padre acreditado. Requiere revisión explícita antes de continuar.",
    "invalidEquivalenceConfirmation": "Esta línea no contiene una equivalencia que se pueda validar.",
    "network": "No hemos podido conectar con el servidor. Comprueba tu conexión.",
    "serviceUnavailable": "El servicio se está recuperando. Espera unos segundos y vuelve a intentarlo.",
    "noFilesProvided": "Añade al menos un archivo.",
    "noFilesToProcess": "Añade al menos un documento antes de procesar.",
    "noLinesToSubmit": "Añade al menos una línea antes de enviar.",
    "pendingProducts": "Identifica todos los productos pendientes antes de continuar.",
    "pendingAtlasSuggestions": "Confirma, cambia o quita los productos sugeridos por Atlas antes de continuar.",
    "documentReviewPending": "Termina la revisión de las lecturas del documento antes de continuar.",
    "pendingEquivalences": "Valida las equivalencias propuestas antes de continuar.",
    "notFound": "No hemos encontrado lo que buscabas.",
    "notificationNotFound": "No hemos encontrado la notificación.",
    "pushNotConfigured": "Las notificaciones push no están configuradas en el servidor.",
    "oauthEmailNotVerified": "El correo de esa cuenta no está verificado.",
    "oauthFailed": "No hemos podido completar el acceso. Inténtalo de nuevo.",
    "oauthNoEmail": "El proveedor no ha facilitado un correo electrónico.",
    "oauthSessionLost": "La sesión de acceso ha caducado. Inténtalo de nuevo.",
    "onlyDraftsCanBeDeleted": "Solo se pueden borrar los borradores.",
    "onlyDraftsOrCancelledCanBeDeleted": "Solo se pueden eliminar borradores o solicitudes canceladas.",
    "requestNotCancelled": "La solicitud no está cancelada.",
    "cancellationExpired": "El plazo para reactivar la solicitud ya ha terminado.",
    "cancellationCannotBeUndone": "Esta cancelación no se puede reactivar.",
    "pageNotFoundText": "El enlace que has seguido no existe o ha cambiado de dirección.",
    "pageNotFoundTitle": "Página no encontrada",
    "passwordTooLong": "La contraseña es demasiado larga.",
    "passwordTooShort": "La contraseña debe tener al menos 10 caracteres.",
    "passwordTooSimple": "La contraseña debe combinar letras y números.",
    "passwordsDontMatch": "Las contraseñas no coinciden.",
    "productImageNotFound": "Ese producto no tiene imagen disponible.",
    "providerNotConfigured": "Ese método de acceso no está disponible ahora mismo.",
    "registrationAlreadyReviewed": "Esa solicitud de alta ya se ha revisado.",
    "registrationNotFound": "No hemos encontrado la solicitud de alta.",
    "requestNotEditable": "Esta solicitud ya no se puede editar.",
    "requestNotFound": "No hemos encontrado la solicitud.",
    "requiredField": "Este campo es obligatorio.",
    "resetLinkInvalid": "El enlace ha caducado o ya se ha utilizado.",
    "routeNotFound": "La dirección solicitada no existe.",
    "ticketNotFound": "No hemos encontrado el ticket.",
    "tooManyAttempts": "Demasiados intentos. Espera unos minutos e inténtalo de nuevo.",
    "tooManyFiles": "Has alcanzado el número máximo de archivos.",
    "tooManyMessages": "Has enviado demasiados mensajes seguidos. Espera un momento.",
    "unauthorized": "Tu sesión ha caducado. Vuelve a iniciar sesión.",
    "unexpected": "Se ha producido un error inesperado. Inténtalo de nuevo.",
    "userNotFound": "No hemos encontrado ese usuario.",
    "cannotModifyOwnAccess": "No puedes retirar tu propio acceso de administrador.",
    "unknownProvider": "Ese método de acceso no existe.",
    "unsupportedFileType": "Ese tipo de archivo no está admitido.",
    "uploadFailed": "No hemos podido subir el archivo.",
    "upstream": "Un servicio externo no ha respondido bien.",
    "validUntilMustBeFuture": "La nueva fecha tiene que ser futura.",
    "validation": "Revisa los datos introducidos.",
    "adaQuoteIncomplete": "Antes de activarla, completa la dirección y la clave.",
    "adaQuoteCustomerCodeMissing": "Falta el código de cliente de AdaQuote en los datos de tu empresa.",
    "adaQuoteReadFailed": "No hemos podido consultar tus presupuestos en Ada-quote. Inténtalo de nuevo.",
    "adaQuotePdfNotReady": "El PDF de este presupuesto todavía no está disponible. Inténtalo más tarde o contacta con administración.",
    "adaQuotePdfCustomerMismatch": "El presupuesto no corresponde al código de cliente de esta solicitud. Contacta con administración.",
    "adaQuotePdfUnavailable": "No se ha podido obtener el PDF del presupuesto. Inténtalo de nuevo.",
    "adaQuotePdfInvalid": "No se ha recibido un PDF válido.",
    "atlasPdfUnavailable": "Atlas todavía no puede entregar el PDF del presupuesto. Inténtalo de nuevo más tarde.",
    "atlasPdfIdentityConflict": "Atlas ha devuelto una identidad de presupuesto distinta. No se mostrará el documento; contacta con administración.",
    "adaQuotePdfNotValidated": "El PDF estará disponible tras la validación comercial.",
    "hermesSignatureRequired": "Para encargar automáticamente hace falta el secreto de firma.",
    "catalogMasterChanged": "El maestro de tarifas ha cambiado durante la copia. Vuelve a intentarlo.",
    "catalogTooManyPages": "La copia del catálogo no termina. Revisa la conexión con Atlas.",
    "catalogNoVersion": "Atlas no ha dicho qué versión del maestro tiene.",
    "catalogProductUnavailable": "El producto elegido ya no está disponible en el catálogo. Actualiza las opciones y vuelve a intentarlo.",
    "recognitionUnusable": "Atlas ha devuelto un resultado que el portal no ha podido guardar. Vuelve a intentarlo.",
    "recognitionVisualAnalysisUnavailable": "El análisis visual de Atlas no está disponible en este momento. Tus archivos están guardados; puedes volver a intentarlo más tarde, sin cambiarlos.",
    "recognitionFailed": "El reconocimiento ha fallado.",
    "documentAnalysisUnavailable": "Atlas no ha podido iniciar el análisis. Tus archivos están guardados; puedes volver a intentarlo más tarde, sin subirlos de nuevo.",
    "recommendationsRejected": "Atlas no ha podido iniciar el análisis de recomendaciones.",
    "recommendationsNeedRecognition": "Esta lista todavía no tiene un reconocimiento que Atlas pueda analizar.",
    "recommendationsNotReady": "Las recomendaciones todavía no están listas.",
    "recommendationNotFound": "Esta recomendación ya no está disponible.",
    "recommendationAlreadyDecided": "Esta recomendación ya se había revisado.",
    "recommendationNeedsInput": "Responde primero las preguntas pendientes de esta recomendación.",
    "recommendationMissingProduct": "Atlas no ha asociado un producto válido a esta recomendación.",
    "recommendationCatalogStale": "El catálogo ha cambiado. Vuelve a analizar las recomendaciones.",
    "recommendationReplacementMissing": "Atlas no ha indicado qué producto debe sustituirse. Vuelve a analizar las recomendaciones.",
    "recommendationsPending": "Revisa las recomendaciones de Atlas antes de enviar la solicitud.",
    "recommendationQuestionsPending": "Responde las preguntas de Atlas antes de continuar.",
    "recommendationDecisionsPending": "Añade o descarta todas las recomendaciones antes de continuar.",
    "unitReviewChanged": "La línea cambió desde que la abriste. Recarga la solicitud y revisa su unidad de nuevo.",
    "unitAnswerUnresolved": "Atlas no ha confirmado la unidad elegida. La pregunta sigue pendiente; tu selección no se ha aplicado.",
    "quantityAnswerUnresolved": "Atlas todavía no ha aplicado la cantidad indicada. La revisión sigue pendiente; vuelve a intentarlo.",
    "installationReferenceSize": "Los archivos de referencia pueden ocupar hasta 10 MB cada uno y 20 MB en total.",
    "installationReferenceInvalid": "El archivo de referencia no se puede leer. Comprueba que sea un PDF o una imagen válida.",
    "installationReferenceLocked": "Para cambiar los archivos, vuelve a la descripción e inicia un nuevo análisis.",
    "installationReferencesUnavailable": "Esta conexión de Atlas todavía no admite archivos de referencia. Los archivos y la descripción están guardados.",
    "requestChangedConcurrently": "La solicitud ha cambiado mientras guardabas. Actualiza la página y vuelve a intentarlo.",
    "semanticResolutionFailed": "Atlas no ha podido completar la interpretación. Vuelve a intentarlo o revisa el documento.",
    "visualReviewConfirmationRequired": "Atlas aún no da por confirmada la lectura de la foto. Usa «Re-analizar» en el menú de la solicitud para leerla de nuevo y confirmarla.",
    "readingConnectionChanged": "La conexión de lectura de esta solicitud ha cambiado. El análisis no se enviará a otro destino.",
    "simpleReadingUnavailable": "La lectura simplificada no está disponible. No se cambiará a otra conexión automáticamente.",
    "simpleReadingFormatUnsupported": "La lectura simplificada admite PDF e imágenes; este tipo de archivo aún no está disponible.",
    "simpleReadingImagesUnchecked": "No se ha podido comprobar si Atlas lee imágenes. Tus archivos siguen guardados; inténtalo de nuevo.",
    "simpleReadingImagesDisabled": "Atlas todavía no lee imágenes en la lectura simplificada. Tu fotografía sigue guardada; podrás analizarla cuando esté disponible.",
    "readingConnectionLocked": "Esta solicitud ya está vinculada a su conexión de lectura. Crea otra solicitud para comparar.",
    "processingRequestChanged": "La solicitud ha cambiado. Actualiza la página antes de analizar.",
    "recognitionJobGone": "Atlas ya no tiene este análisis. Tus archivos siguen guardados; vuelve a analizarlos.",
    "recognitionServiceUnavailable": "Atlas lleva varios minutos sin responder sobre este análisis. Tus archivos siguen guardados; vuelve a intentarlo más tarde.",
    "recognitionStartInterrupted": "No pudimos confirmar el inicio del análisis. Tus archivos siguen guardados; vuelve a analizarlos.",
    "recognitionNotRestarted": "Atlas no ha empezado una lectura nueva porque aún conserva la anterior. Espera unos minutos y vuelve a analizar.",
    "typedTextEmpty": "Escribe primero tu listado o la descripción de tu instalación.",
    "typedTextInvalidCharacters": "El texto contiene caracteres que Atlas no puede leer (por ejemplo, caracteres de control pegados desde otro programa). Quítalos y vuelve a enviarlo.",
    "typedTextTooLarge": "El texto es demasiado largo para que Atlas lo lea de una vez (máximo 4.000 caracteres y 16 KB). Acórtalo o divídelo en varias solicitudes.",
    "typedTextTooManyLines": "El texto tiene demasiadas líneas para que Atlas lo lea de una vez (máximo 300). Agrupa las líneas o divídelo en varias solicitudes.",
    "typedTextRequiresOneFile": "Atlas lee el texto escrito solo, sin otros documentos. Quita los documentos o envía el texto en otra solicitud.",
    "typedTextNoMaterials": "Atlas no ha encontrado ningún producto en el texto. Revísalo (por ejemplo, «20 rosetas cat6») o descríbelo como una instalación.",
    "typedTextUnsupported": "Esta conexión de Atlas todavía no lee textos escritos como listado. Envía la descripción como instalación o rellena el listado manualmente.",
    "twoFactorInvalid": "El código no es correcto. Inténtalo de nuevo.",
    "twoFactorExpired": "El código ha caducado o ya se ha utilizado. Vuelve a iniciar sesión.",
    "twoFactorLocked": "Demasiados intentos. Espera 15 minutos antes de volver a acceder.",
    "twoFactorResendWait": "Espera antes de solicitar otro código. Si has agotado los reenvíos, vuelve a iniciar sesión.",
    "twoFactorDelivery": "No se ha podido enviar el código por correo. Vuelve a intentarlo más tarde.",
    "closedOrderRecommendationsDisabled": "Los pedidos cerrados pasan de Revisión a Confirmación sin recomendaciones.",
    "wordConverterUnavailable": "La conversión de Word a PDF no está disponible. Sube el documento como PDF o inténtalo de nuevo más tarde.",
    "wordConversionFailed": "No se ha podido convertir el documento Word a PDF. Comprueba que no esté dañado ni protegido con contraseña, o súbelo como PDF.",
    "resetRequiresActiveUser": "Solo se puede solicitar el cambio de contraseña de una cuenta activa.",
    "passwordChangeRequired": "Un administrador ha solicitado cambiar tu contraseña. Abre el enlace del correo o solicita uno desde ¿Has olvidado tu contraseña? para volver a acceder.",
    "cannotForceOwnPasswordReset": "Cambia tu propia contraseña desde tu perfil.",
    "passwordResetCooldown": "Espera un minuto antes de volver a enviar el correo.",
    "passwordResetEmailFailed": "No se ha podido enviar el correo. La cuenta no se ha bloqueado; comprueba la configuración de correo y vuelve a intentarlo.",
    "cannotDeleteOwnUser": "No puedes borrar tu propia cuenta.",
    "userSecurityChanged": "La cuenta ha cambiado durante la operación. Actualiza la lista y vuelve a intentarlo.",
    "customerOrderRequired": "Las solicitudes con cliente asignado se envían con «Ganado y pasar a pedido».",
    "customerOrderUnavailable": "El paso a pedido todavía no está disponible en Atlas.",
    "customerOrderInvalid": "Atlas ha devuelto una respuesta de pedido no válida.",
    "customerOrderConflict": "La solicitud ha cambiado. Recarga y vuelve a intentarlo.",
    "customerOrderUnreachable": "No se ha podido contactar con Atlas. Puedes reintentarlo: no se duplicará el pedido.",
    "customerOrderNotApplicable": "Esta solicitud no tiene cliente asignado.",
    "customerOrderDataMissing": "Para pasar a pedido faltan la fecha de entrega o el número de pedido del cliente (paso 1).",
    "atlasMaintenance": "Atlas está en mantenimiento. La solicitud queda en cola y se procesará automáticamente al terminar."
  },
  "help": {
    "title": "Centro de ayuda",
    "subtitle": "Resuelve tus dudas sobre el portal y el proceso de presupuesto.",
    "guides": "Guías",
    "faq": "Preguntas frecuentes",
    "contactTitle": "¿Necesitas ayuda?",
    "contactText": "Cuéntanos qué ocurre e indica la referencia de la solicitud o del presupuesto, si la tienes.",
    "contactCta": "Contactar con soporte",
    "guidePhotoTitle": "Cómo hacer una buena fotografía",
    "guidePhotoIntro": "Consigue un reconocimiento más preciso preparando bien cada imagen.",
    "guidePhotoStep1": "Coloca la lista sobre una superficie plana y con buena luz.",
    "guidePhotoStep2": "Encuadra la hoja completa, sin cortar referencias ni cantidades.",
    "guidePhotoStep3": "Evita reflejos, sombras y fotografías inclinadas.",
    "guidePhotoStep4": "Comprueba que el texto se lee antes de continuar.",
    "guidePhotoTip": "Si hay varias páginas, fotografíalas en orden. Podrás revisar todas antes de iniciar el procesamiento.",
    "guideLinesTitle": "Cómo corregir los componentes",
    "guideLinesIntro": "Comprueba la lectura del documento y el producto elegido antes de enviar el listado.",
    "guideLinesStep1": "Si aparecen Lecturas por confirmar, revisa el texto, la cantidad y la unidad de cada fila. Usa editar para corregirlos y confirmar para guardar la lectura.",
    "guideLinesStep2": "Confirmar el texto no identifica siempre el producto. Si Atlas pide elegir una referencia, responde la pregunta o busca el producto en el catálogo por código o referencia.",
    "guideLinesStep3": "En el listado de materiales, comprueba el producto, la cantidad y la unidad. Abre editar para modificar la fila; confirma las filas que requieran tu validación.",
    "guideLinesStep4": "Quita o excluye los materiales que no quieras incluir cuando la pantalla lo permita. Resuelve las cantidades o unidades pendientes antes de continuar.",
    "guideLinesTip": "Una referencia bien reconocida no sustituye la revisión de la cantidad y la unidad. Comprueba, por ejemplo, si un cable se solicita en metros o en unidades.",
    "guideBudgetTitle": "Cómo se genera el presupuesto",
    "guideBudgetIntro": "Conoce el recorrido desde tu listado hasta la propuesta comercial.",
    "guideBudgetStep1": "Revisa los materiales, sus cantidades y unidades. Responde las preguntas pendientes de Atlas y decide sobre las sugerencias que se muestren.",
    "guideBudgetStep2": "En Confirmación, revisa el resumen y marca que has revisado los materiales y las cantidades. Pulsa Enviar solicitud para pedir el presupuesto.",
    "guideBudgetStep3": "Consulta el progreso en Mis solicitudes y las notificaciones. Cuando el presupuesto esté disponible, ábrelo desde Presupuestos.",
    "guideBudgetStep4": "Revisa los precios y las condiciones. Descarga el documento cuando esté disponible y utiliza las acciones de aprobación, cambios o rechazo que ofrezca el presupuesto.",
    "guideBudgetTip": "El importe mostrado antes del envío es una estimación. Comprueba los precios y las condiciones del presupuesto generado antes de aprobarlo.",
    "guidePrivacyTitle": "Privacidad de tus documentos",
    "guidePrivacyIntro": "Tus archivos se utilizan únicamente para gestionar la solicitud.",
    "guidePrivacyStep1": "Los documentos quedan asociados a tu cuenta de cliente.",
    "guidePrivacyStep2": "Solo el personal autorizado puede consultar su contenido.",
    "guidePrivacyStep3": "Puedes solicitar información sobre conservación o eliminación.",
    "guidePrivacyStep4": "No compartimos tus archivos para fines publicitarios.",
    "guidePrivacyTip": "Consulta la política de privacidad completa para obtener más información.",
    "faqTimeQ": "¿Cuánto tarda en llegar mi presupuesto?",
    "faqTimeA": "El plazo depende del análisis y de las comprobaciones necesarias. Puedes consultar el estado en Mis solicitudes; recibirás una notificación cuando haya novedades.",
    "faqEditQ": "¿Puedo modificar una solicitud ya enviada?",
    "faqEditA": "Una vez enviada no se puede editar, pero puedes escribirnos desde soporte indicando la referencia.",
    "faqFormatsQ": "¿Qué formatos de archivo puedo subir?",
    "faqFormatsA": "Puedes subir imágenes JPG, PNG, WEBP o HEIC, PDF y hojas de cálculo XLSX, XLS o CSV. Se admiten varios archivos en una solicitud; revisa que todos aparezcan adjuntos antes de analizar.",
    "faqPriceQ": "¿Los precios incluyen IVA?",
    "faqPriceA": "El detalle muestra la base imponible y el IVA por separado, y el total con impuestos incluidos.",
    "shortcuts": "Accesos directos",
    "privacyAction": "Ver política de privacidad",
    "guideStartTitle": "Cómo crear una solicitud",
    "guideStartIntro": "Elige el método que mejor encaje con la información que tienes.",
    "guideStartStep1": "Pulsa Nueva solicitud y completa los datos del proyecto. Conserva la referencia SOL para localizarlo después.",
    "guideStartStep2": "Si tienes un listado, puedes hacer una fotografía o subir archivos PDF, imágenes, Excel o CSV. Puedes adjuntar varios archivos, por ejemplo un PDF y una imagen.",
    "guideStartStep3": "Si conoces los productos, elige Rellenar manualmente y búscalos por código o referencia. Si necesitas que Atlas proponga los materiales, elige Describe tu instalación a Atlas.",
    "guideStartStep4": "Revisa los materiales y las sugerencias. En la confirmación final, comprueba el resumen, marca que has revisado el listado y pulsa Enviar solicitud.",
    "guideStartTip": "Enviar una descripción o subir un archivo inicia el análisis. El envío final de la solicitud se realiza después de tu revisión.",
    "guideAtlasTitle": "Describe tu instalación a Atlas",
    "guideAtlasIntro": "Explica qué necesitas y revisa los materiales que Atlas propone.",
    "guideAtlasStep1": "En una nueva solicitud, selecciona Describe tu instalación a Atlas. Indica el objetivo, las zonas o plantas, las cantidades previstas y los equipos o el cableado que ya tienes. También puedes adjuntar planos, fotos o PDFs como referencia.",
    "guideAtlasStep2": "Pulsa Enviar propuesta. Si faltan detalles, abre cada tema, responde los pasos del diálogo y guarda las respuestas. Cuando completes los temas, pulsa Enviar respuestas.",
    "guideAtlasStep3": "Cuando la propuesta esté lista, comprueba código, referencia, descripción y cantidad de cada material. Puedes confirmar, editar desde el catálogo o quitar filas.",
    "guideAtlasStep4": "Revisa la explicación de los componentes y las sugerencias que presente Atlas. Decide cuáles añadir y espera a que termine la revisión técnica; si queda una duda, el portal te la mostrará.",
    "guideAtlasStep5": "En Confirmación, revisa el listado y el importe disponible. Marca que has revisado los materiales y las cantidades y pulsa Enviar solicitud.",
    "guideAtlasTip": "Los materiales provisionales son una vista previa. Las acciones estarán disponibles cuando Atlas complete sus comprobaciones; puedes salir y retomar la solicitud.",
    "guideResumeTitle": "Cómo retomar una solicitud",
    "guideResumeIntro": "Continúa una revisión guardada y consulta qué está pendiente.",
    "guideResumeStep1": "Durante el análisis puedes usar Salir o Salir y continuar más tarde. Abre Mis solicitudes y selecciona la referencia SOL para retomar el paso pendiente.",
    "guideResumeStep2": "Si Atlas está procesando o realizando comprobaciones técnicas, espera y consulta el estado. Una vista previa de materiales no significa que la propuesta esté lista para confirmar.",
    "guideResumeStep3": "Si hay preguntas, lecturas, cantidades o unidades pendientes, completa lo indicado en pantalla. Revisa también las notificaciones para conocer los avances.",
    "guideResumeStep4": "Si aparece un error, usa Intentar de nuevo cuando se ofrezca. Si persiste, contacta con soporte indicando la referencia, el paso y lo que ocurrió; una captura ayuda.",
    "guideResumeTip": "Antes de salir de un diálogo, guarda las respuestas o los cambios. Comprueba que las confirmaciones han terminado de guardarse antes de cerrar la pantalla.",
    "faqReadingQ": "¿Por qué tengo que confirmar una lectura?",
    "faqReadingA": "Atlas puede necesitar validar el texto, una cantidad o una unidad del documento. Confirmar la lectura guarda esos datos; si aún falta identificar el producto, aparecerá una pregunta para elegirlo.",
    "faqSavedQ": "¿Puedo salir mientras Atlas trabaja?",
    "faqSavedA": "Sí. La solicitud queda guardada y puedes retomarla desde Mis solicitudes. Guarda antes los cambios de los diálogos y espera a que terminen las confirmaciones en curso.",
    "faqPendingQ": "¿Qué significa Pendiente de Atlas?",
    "faqPendingA": "Atlas aún está completando el análisis o sus comprobaciones. Si no hay preguntas para ti, consulta el estado más tarde. Los materiales provisionales no se pueden validar hasta que la propuesta esté lista.",
    "faqUnavailableQ": "¿Por qué un enlace dice que la solicitud o el presupuesto no está disponible?",
    "faqUnavailableA": "El elemento puede haberse eliminado o el enlace puede ser incorrecto. Vuelve a su listado para localizarlo. Si esperabas tener acceso y no aparece, consulta con soporte indicando la referencia."
  },
  "languages": {
    "es": "Español",
    "en": "English",
    "fr": "Français",
    "it": "Italiano"
  },
  "lineConfidence": {
    "high": "Reconocimiento alto",
    "review": "Revisar referencia",
    "incomplete": "Dato incompleto",
    "corrected": "Corregido por ti",
    "confirmed": "Confirmado",
    "manual": "Introducido manualmente"
  },
  "nav": {
    "home": "Inicio",
    "newRequest": "Nueva solicitud",
    "requests": "Solicitudes",
    "budgets": "Presupuestos",
    "assistant": "Asistente Atlas",
    "admin": "Administración",
    "notifications": "Notificaciones",
    "help": "Ayuda",
    "profile": "Perfil",
    "support": "Soporte",
    "privacy": "Privacidad",
    "signOut": "Cerrar sesión",
    "signingOut": "Cerrando sesión…",
    "mobileNew": "Nueva",
    "mobileHome": "Inicio",
    "mobileRequests": "Solicitudes",
    "mobileBudgets": "Presupuestos",
    "mobileAssistant": "Asistente",
    "mobileProfile": "Perfil",
    "changeLanguage": "Cambiar idioma",
    "mainNavigation": "Navegación principal",
    "mobileNavigation": "Navegación móvil",
    "hideSidebar": "Plegar el menú",
    "showSidebar": "Desplegar el menú",
    "preferences": "Preferencias",
    "legalNotice": "Aviso legal",
    "cookies": "Cookies",
    "legalInformation": "Información legal"
  },
  "notifications": {
    "budgetApprovedBody": "Has aprobado {{ref}} · {{project}}. Adaltra prepara el pedido.",
    "budgetApprovedTitle": "Presupuesto aprobado",
    "budgetChangesBody": "Adaltra revisará {{ref}} · {{project}} y te enviará una propuesta corregida.",
    "budgetChangesTitle": "Cambios pedidos",
    "budgetExpiringBody": "Apruébalo antes de la fecha de validez.",
    "budgetExpiringTitle": "El presupuesto {{ref}} caduca pronto",
    "budgetExtendedBody": "Hemos ampliado la validez de {{ref}}. Ya puedes decidir con más margen.",
    "budgetExtendedTitle": "Presupuesto prorrogado",
    "budgetReadyBody": "Ya puedes revisarlo y descargarlo.",
    "budgetReadyTitle": "Tu presupuesto {{ref}} está listo",
    "budgetRejectedBody": "Has rechazado {{ref}} · {{project}}.",
    "budgetRejectedTitle": "Presupuesto rechazado",
    "budgetReminderBody": "{{ref}} sigue pendiente de tu decisión.",
    "budgetReminderTitle": "Tienes un presupuesto esperando",
    "budgetWithdrawnBody": "{{ref}} ya no está disponible. Escríbenos si sigue interesándote.",
    "budgetWithdrawnTitle": "Presupuesto retirado",
    "emptyText": "Te avisaremos aquí cuando haya novedades.",
    "emptyTitle": "No tienes notificaciones",
    "markAllRead": "Marcar todas como leídas",
    "panelError": "No hemos podido cargar las notificaciones.",
    "panelUnread": "{{count}} sin leer",
    "viewAll": "Ver todas las notificaciones",
    "settingsButton": "Ajustes",
    "settingsTitle": "Ajustes de notificaciones",
    "deleteAll": "Borrar",
    "deleteConfirmText": "Se eliminará todo el historial de notificaciones. Esta acción no se puede deshacer.",
    "deleteConfirmTitle": "¿Borrar todas las notificaciones?",
    "channelsTitle": "Avisos en todos tus dispositivos",
    "channelsText": "Los correos y los avisos push siguen tus preferencias. Activa push en cada dispositivo donde quieras recibirlos.",
    "enablePush": "Activar push",
    "disablePush": "Desactivar push",
    "pushChecking": "Comprobando push",
    "pushInactive": "Push desactivado",
    "pushBlocked": "Push bloqueado",
    "pushUnavailable": "Push no disponible",
    "channelsTextActive": "Los avisos push están activados en este dispositivo y siguen tus preferencias. Puedes desactivarlos cuando quieras.",
    "pushActive": "Push activo",
    "pushEnabled": "Las notificaciones push están activadas en este dispositivo.",
    "pushDisabled": "Las notificaciones push se han desactivado en este dispositivo.",
    "pushDenied": "El navegador tiene bloqueadas las notificaciones para Atlas.",
    "pushError": "No hemos podido cambiar la configuración de las notificaciones push.",
    "pushRequiresHttps": "Las notificaciones push y la instalación requieren una conexión HTTPS segura.",
    "pushNotConfigured": "Faltan las claves VAPID del servidor para activar las notificaciones push.",
    "emailNotConfigured": "Falta configurar el servidor SMTP para enviar correos.",
    "installApp": "Instalar app",
    "appInstalled": "App instalada",
    "installHint": "En iPhone o iPad, usa Compartir → Añadir a pantalla de inicio.",
    "quoteFailedBody": "Ha habido un problema con {{ref}}. Lo estamos revisando.",
    "quoteFailedTitle": "No hemos podido preparar el presupuesto",
    "quoteReadyBody": "{{ref}} ya se puede consultar y aceptar.",
    "quoteInReviewTitle": "Tu presupuesto está en revisión",
    "quoteInReviewBody": "{{ref}} ya se puede consultar. Un comercial lo está revisando antes de enviártelo.",
    "quoteRejectedByAdaQuoteBody": "{{ref}} no ha superado la revisión comercial.",
    "quoteRejectedByAdaQuoteTitle": "Presupuesto no aprobado",
    "quoteReadyTitle": "Tu presupuesto está listo",
    "requestProcessedBody": "Atlas ha preparado {{ref}}. Revisa los productos antes de enviarla.",
    "requestProcessedTitle": "Solicitud pendiente de revisión",
    "requestReadingFailedTitle": "Error al analizar los documentos",
    "requestReadingFailedBody": "Atlas no ha podido completar el análisis de {{ref}}. Abre la solicitud para consultar el error y volver a intentarlo.",
    "requestReceivedBody": "Atlas ha empezado a preparar tu presupuesto.",
    "requestReceivedTitle": "Solicitud {{ref}} recibida",
    "requestSubmittedBody": "{{ref}} · {{project}} está en manos de Atlas.",
    "requestSubmittedTitle": "Solicitud enviada",
    "subtitle": "Todo lo que ha pasado con tus solicitudes y presupuestos.",
    "title": "Notificaciones",
    "unread": "Sin leer",
    "maintenanceQueueStartedTitle": "Solicitud enviada a Atlas",
    "maintenanceQueueStartedBody": "Ha terminado el mantenimiento y {{ref}} ya se está procesando.",
    "maintenanceQueueFailedTitle": "No se pudo procesar la solicitud en cola",
    "maintenanceQueueFailedBody": "{{ref}} no pudo enviarse a Atlas al terminar el mantenimiento. Ábrela y pulsa «Analizar» de nuevo."
  },
  "privacy": {
    "title": "Política de privacidad",
    "subtitle": "Cómo tratamos la información que compartes con Adaltra.",
    "section1Title": "Datos que recogemos",
    "section1Text": "Los datos de contacto de tu cuenta, los de tu empresa y los documentos que subes para preparar un presupuesto.",
    "section2Title": "Para qué los usamos",
    "section2Text": "Únicamente para gestionar tus solicitudes, elaborar los presupuestos y darte soporte. No los cedemos con fines publicitarios.",
    "section3Title": "Conservación",
    "section3Text": "Mantenemos los documentos mientras dure la relación comercial y durante los plazos que exige la normativa fiscal.",
    "section4Title": "Tus derechos",
    "section4Text": "Puedes solicitar el acceso, la rectificación o la eliminación de tus datos escribiendo a nuestro equipo de soporte."
  },
  "profile": {
    "title": "Tu perfil",
    "subtitle": "Gestiona tus datos y los de tu empresa.",
    "personalData": "Datos personales",
    "companyData": "Datos de la empresa",
    "security": "Seguridad",
    "preferences": "Preferencias",
    "language": "Idioma",
    "languageHint": "Se aplicará a todo el portal y a los correos que recibas.",
    "address": "Dirección",
    "city": "Población",
    "postalCode": "Código postal",
    "province": "Provincia",
    "adaQuoteCustomerCode": "Código de cliente de AdaQuote",
    "adaQuoteCustomerCodeHint": "Código comercial asignado a tu empresa en AdaQuote.",
    "adaQuoteCustomerCodeReadOnlyHint": "Código comercial asignado por Adaltra. Puedes consultarlo, pero solo un administrador puede modificarlo.",
    "linkedAccounts": "Cuentas vinculadas",
    "linkedAccountsHint": "Puedes acceder al portal con cualquiera de ellas.",
    "companyReadOnly": "Solo el gestor de la cuenta puede modificar los datos fiscales. Escríbenos si necesitas cambiarlos.",
    "passwordChanged": "Contraseña actualizada",
    "session": "Sesión",
    "sessionHint": "Cierra la sesión en este dispositivo."
  },
  "request": {
    "dateNotPast": "No puede ser anterior a hoy.",
    "orderAssignment": {
      "previewLabel": "Disponible",
      "savedLabel": "Guardado",
      "savedHint": "Datos guardados en la solicitud.",
      "previewHint": "Selecciona el cliente y su dirección de entrega. Los datos del pedido se guardarán al continuar o guardar los cambios.",
      "retryConnection": "Reintentar conexión",
      "noCustomers": "Sin clientes coincidentes",
      "noAddresses": "Sin direcciones disponibles",
      "connecting": "Conectando con Atlas…",
      "searchHint": "Escribe al menos dos caracteres del nombre, código o NIF.",
      "sourceCount": "Clientes disponibles en Atlas: {{count}}",
      "staleCopy": "Copia pendiente de actualizar",
      "previewSummaryHint": "El resumen se actualizará al completar los campos y se guardará con la solicitud.",
      "summaryAddress": "Dirección",
      "summaryDate": "Fecha de entrega",
      "summaryOrderNumber": "Número de pedido",
      "summaryCustomer": "Cliente",
      "title": "Asignar cliente y dirección de entrega",
      "soon": "Próximamente",
      "hint": "La selección de clientes y direcciones se habilitará cuando esté disponible el maestro de Atlas.",
      "customer": "Buscar cliente (nombre, código o NIF)",
      "taxId": "NIF",
      "customerHint": "Clientes importados desde Atlas.",
      "address": "Dirección de entrega / envío (numdir)",
      "addressHint": "Selecciona primero un cliente para consultar sus direcciones.",
      "date": "Fecha de entrega (instalación)",
      "dateHint": "Fecha de entrega prevista.",
      "orderNumber": "Número pedido cliente",
      "useProjectName": "Copiar nombre del proyecto",
      "orderHint": "Número de pedido del cliente.",
      "summary": "Resumen del pedido",
      "summaryHint": "Cuando se habilite esta función, los datos que aparecen a continuación se actualizarán al completar los campos del formulario."
    },
    "atlasTestConfirmSubtitle": "Este es el listado resultante de la prueba de lectura de Atlas Test.",
    "readingConnectionLabel": "Conexión de lectura",
    "readingConnectionCurrent": "Atlas actual",
    "readingConnectionSimple": "Lectura simplificada (B)",
    "readingConnectionNotReady": "pendiente de configuración",
    "readingConnectionHelp": "Elige la conexión antes del primer análisis. Crea solicitudes distintas para comparar el mismo documento.",
    "readingConnectionLocked": "Esta solicitud conserva su conexión de lectura para todo el análisis y la revisión.",
    "atlasTestNotice": "Prueba de lectura. Puedes revisar los resultados; el envío de presupuestos y pedidos está bloqueado.",
    "mandatoryDependencyConflict": "Hay licencias que necesitan revisión",
    "mandatoryDependencyConflictHint": "Se han conservado tus líneas. Revisa las licencias y vuelve a analizar antes de continuar.",
    "mandatoryDependencyWarning": "Atlas ha detectado datos de cobertura que conviene revisar.",
    "confirmAllAndContinue": "Confirmar todo y continuar",
    "continueRecognizedList": "Continuar con este listado",
    "continueRecognizedListHint": "Se conservarán los {{count}} artículos de la tabla, sin añadir otros fragmentos del documento.",
    "previousIdentificationStep": "Volver al paso anterior",
    "identifyAction": "Identificar",
    "identifyInTableHint": "Identifica cada producto desde su fila. Atlas te guiará paso a paso.",
    "rackScopeHint": "Asigna cada componente a su rack o déjalo independiente. No se cambiarán las partidas ya delimitadas por Atlas.",
    "rackScopeChoose": "Selecciona el destino",
    "rackScopeIndependent": "Independiente (sin rack)",
    "rackScopeAssigned": "Asignación completada",
    "rackScopeUnavailable": "Atlas debe completar los datos de esta asignación antes de continuar.",
    "rackScopeLine": "Componente",
    "commercialRejectionSummary": "Consulta el resultado de la revisión comercial.",
    "partialRejectionText": "La validación se ha completado. Estas líneas se han rechazado; el resto de productos aceptados continúa en el borrador.",
    "validationCompleted": "Validación comercial completada",
    "validationCounts": "Productos aceptados: {{accepted}} · Rechazados: {{rejected}}",
    "validationDraft": "Borrador {{ref}} creado en AdaQuote. El presupuesto definitivo y sus precios todavía no están disponibles.",
    "lineRejectedCommercially": "Rechazado por el comercial",
    "lineAcceptedCommercially": "Aceptado por el comercial",
    "viewRejectionReasons": "Ver motivos del rechazo",
    "rejectionReasonsTitle": "Motivos del rechazo",
    "rejectionReasonsUnavailable": "No se han recibido motivos adicionales.",
    "commercialRejectionText": "La solicitud no ha sido aprobada en la revisión comercial. A continuación puedes consultar los motivos recibidos.",
    "rejectedLine": "Producto {{number}}",
    "placeOrder": "Realizar pedido",
    "adaQuotePdfTitle": "PDF del presupuesto · {{number}}",
    "loadingAdaQuotePdf": "Cargando PDF del presupuesto…",
    "preparationTransition": "Abriremos el estado de tu solicitud en {{count}} s.",
    "customerCodeBlockedHelp": "Un administrador debe completar los datos de cliente. Los productos revisados se conservan y el reenvío permanece bloqueado hasta resolverlo.",
    "checkCustomerCode": "Comprobar datos",
    "retrySubmission": "Reenviar a Atlas",
    "recoverReference": "Recuperar listado",
    "recoveredReferenceHelp": "El listado tiene un número nuevo. Revisa los materiales y vuelve a confirmar el envío. Los documentos permanecen en la solicitud original.",
    "viewOriginalRequest": "Ver solicitud original",
    "customerCodeReady": "El código de cliente ya está disponible. Puedes reenviar la solicitud a Atlas.",
    "addFile": "Añadir archivo",
    "addMoreFiles": "Añadir otros archivos",
    "addLine": "Añadir producto",
    "addLineAfterReading": "Termina la revisión de las lecturas del documento. Mientras tanto, puedes añadir productos manualmente.",
    "addRow": "Añadir fila",
    "analyzingHint": "Puedes cerrar esta página: el trabajo sigue por nuestra parte.",
    "analyzingStepIssuing": "Emitiendo el presupuesto",
    "analyzingStepMatching": "Cruzando referencias",
    "analyzingStepPricing": "Aplicando precios",
    "analyzingStepReceived": "Listado recibido",
    "analyzingText": "Hemos recibido tu listado y lo estamos valorando. Te avisaremos en cuanto el presupuesto esté disponible.",
    "analyzingTitle": "Atlas está preparando tu presupuesto",
    "commercialReviewHint": "Te avisaremos cuando termine.",
    "commercialReviewStepAnalyzing": "Revisión comercial en curso",
    "commercialReviewStepChecking": "Comprobando productos y condiciones",
    "commercialReviewStepReceived": "Recibido por el equipo comercial",
    "commercialReviewStepValidating": "Validando la propuesta",
    "commercialReviewText": "Un comercial está comprobando la propuesta antes de enviártela.",
    "commercialReviewTitle": "Tu presupuesto está en revisión",
    "backHome": "Volver al inicio",
    "cancelDialogText": "Adaltra dejará de trabajar en ella. Podrás reactivarla durante 7 días; después se eliminará definitivamente junto con sus documentos.",
    "cancelDialogTitle": "¿Cancelar esta solicitud?",
    "cancelProcess": "Cancelar el proceso",
    "cancelProcessEmptyText": "Volverás al inicio. Como todavía no has guardado ningún dato, no se eliminará ninguna solicitud.",
    "cancelProcessTitle": "¿Cancelar este proceso?",
    "cancelRequest": "Cancelar la solicitud",
    "cancelledMessage": "Solicitud cancelada",
    "cancelledCleanupNotice": "Esta solicitud se eliminará automáticamente el {{date}}. Hasta entonces puedes reactivarla.",
    "cancelledCleanupList": "Se eliminará automáticamente el {{date}}",
    "deletePermanently": "Eliminar definitivamente",
    "permanentDeleteTitle": "¿Eliminar definitivamente esta solicitud?",
    "permanentDeleteText": "«{{name}}» y sus documentos se eliminarán ahora. Ya no podrás reactivar la solicitud ni deshacer esta acción.",
    "permanentlyDeleted": "Solicitud eliminada definitivamente",
    "changeMethod": "Cambiar método",
    "chooseMethod": "Elige cómo quieres añadir los productos. Podrás revisar y editar el listado antes de solicitar el presupuesto.",
    "confirmCheck": "He revisado el listado y confirmo que los datos son correctos.",
    "confirmBeforeSubmit": "Confirma que has revisado el listado antes de enviar la solicitud.",
    "confirmNavigation": "Navegación de la confirmación",
    "confirmPendingFooter": "Confirma el listado",
    "confirmReadyFooter": "Listo para enviar",
    "confirmSubtitle": "Este es el listado que enviaremos a Atlas para preparar tu presupuesto.",
    "confirmTitle": "Confirma tu solicitud",
    "estimatedPvpTitle": "Estimación PVP",
    "estimatedSubtotal": "PVP sin IVA",
    "estimatedVat": "IVA ({{rate}} %)",
    "estimatedTotal": "Total con IVA",
    "estimatedTotalPartial": "Total parcial con IVA",
    "estimatedNoValuedLines": "Estimación pendiente: aún no hay productos valorados.",
    "estimatedPvpNote": "Total aproximado calculado con PVP de tarifa, sin descuentos aplicados.",
    "estimatedUnpricedIntro": "Productos pendientes de valoración:",
    "estimatedUnpricedProduct": "{{product}} — PVP: {{price}}",
    "estimatedUnpricedReasonProduct": "{{product}} — {{reasons}}",
    "estimatedQuantityPending": "Cantidad pendiente",
    "estimatedCommercialBasisPending": "Unidad de compra en revisión comercial",
    "estimatedUnitPending": "Unidad pendiente",
    "estimatedUnpricedPriceReason": "PVP: {{price}}",
    "estimatedPriceUnavailable": "No disponible",
    "estimatedPartial_one": "Queda {{count}} producto por valorar; el total mostrado es parcial.",
    "estimatedPartial_other": "Quedan {{count}} productos por valorar; el total mostrado es parcial.",
    "continueDraft": "Continuar",
    "dataSaved": "Datos del proyecto actualizados",
    "desiredDate": "Fecha deseada",
    "detailDocuments": "Documentos",
    "detailTimeline": "Seguimiento",
    "detailTitle": "Detalle de la solicitud",
    "discardDraft": "Descartar",
    "discardDraftConfirm": "Descartar borrador",
    "discardDraftText": "«{{name}}» se borrará con las fotos y las líneas que hayas añadido. No se puede deshacer.",
    "discardDraftTitle": "¿Descartar este borrador?",
    "draftDiscarded": "Borrador descartado.",
    "draftLabel": "Solicitud a medias",
    "draftSaved": "Borrador guardado",
    "draftText": "La empezaste y no llegaste a enviarla.",
    "editData": "Editar los datos",
    "editLine": "Editar línea",
    "emptyText": "Cuando envíes tu primera lista de materiales aparecerá aquí.",
    "emptyTitle": "Todavía no hay solicitudes",
    "excludeLine": "Quitar del listado",
    "excluded": "Excluida",
    "filesAdded": "Archivos añadidos",
    "filesReady_one": "{{count}} archivo listo para procesar",
    "filesReady_other": "{{count}} archivos listos para procesar",
    "goToRequests": "Ver mis solicitudes",
    "humanNoteText": "Este listado incluye los materiales que has revisado y las sugerencias que has aceptado.",
    "humanNoteTitle": "Atlas también completará la solución",
    "inProgressProcessing": "Leyendo tu listado",
    "inProgressSubmitted": "Preparando el presupuesto",
    "inProgressQuoteReview": "Un comercial está revisando el presupuesto",
    "includeLine": "Incluir en el presupuesto",
    "itemsCount_one": "{{count}} artículo",
    "itemsCount_other": "{{count}} artículos",
    "leaveAndContinue": "Salir y continuar más tarde",
    "leaveDraft": "Salir",
    "materialsNavigation": "Navegación de productos",
    "addMaterialsFirst": "Añade al menos un producto o archivo para continuar",
    "processWithAtlas": "Analizar con Atlas",
    "linesDetected_one": "{{count}} línea detectada",
    "linesDetected_other": "{{count}} líneas detectadas",
    "listSubtitle": "Consulta el estado de todo lo que has enviado.",
    "listTitle": "Mis solicitudes",
    "paginationSummary": "{{from}}–{{to}} de {{total}} solicitudes",
    "perPage": "Por página",
    "paginationAria": {
      "page": "Ir a la página {{page}}",
      "first": "Ir a la primera página",
      "last": "Ir a la última página",
      "next": "Ir a la página siguiente",
      "previous": "Ir a la página anterior"
    },
    "location": "Lugar de instalación",
    "locationPlaceholder": "Ciudad o dirección",
    "manualEntry": "Rellenar manualmente",
    "manualEntryHint": "Añade los productos uno a uno",
    "manualHint": "Añade productos propios o activa Otras marcas para buscar equivalencias línea por línea.",
    "externalManufacturer": "Marca ext.",
    "otherBrands": "Otras marcas",
    "externalCode": "Código/ref. externo",
    "equivalence": {
      "resolved": "Equivale a {{product}} según Atlas.",
      "resolvedDetail": "{{source}} → {{product}}",
      "searching": "Buscando equivalencias en Atlas…",
      "noCandidates": "Sin candidatos acreditados",
      "validated": "Validado",
      "proposal": "Propuesta",
      "score": "Nota {{score}}/100",
      "notFound": "Atlas no tiene una equivalencia acreditada.",
      "unavailable": "No se pudo consultar el mapa de equivalencias."
    },
    "fromCatalog": "Del catálogo",
    "fromCatalogHint": "Los datos de un artículo del catálogo no se pueden cambiar aquí. Para escribirlo a mano, borra el código.",
    "catalogSearching": "Buscando en el catálogo…",
    "catalog": {
      "ambiguous": "Hay varios artículos que encajan. Elige uno de la lista.",
      "notFound": "No está en el catálogo. Puedes describirlo a mano.",
      "unavailable": "No hemos podido consultar el catálogo. Rellena la fila a mano."
    },
    "manualTitle": "Lista manual de productos",
    "noCatalogResults": "Sin coincidencias en el catálogo",
    "notes": "Observaciones",
    "notesPlaceholder": "Añade cualquier detalle que debamos tener en cuenta…",
    "phaseFinishing": "Preparando el listado para su revisión",
    "phaseValidatingResult": "Validando el listado completo",
    "phaseIdentifying": "Identificando referencias y cantidades",
    "phasePreparing": "Preparando el documento",
    "phaseReading": "Reconociendo el texto",
    "processingCompleted": "{{percent}} % completado",
    "processingErrorText": "Atlas no ha podido completar el análisis de los archivos. Puedes volver a intentarlo con los archivos guardados o añadir otros.",
    "processingErrorTitle": "No hemos podido completar el análisis",
    "returnToPreviousReview": "Volver al listado anterior",
    "processingRemaining": "Atlas sigue trabajando",
    "processingSavedText": "No perderás los datos del proyecto.",
    "processingSavedTitle": "Tu solicitud se ha guardado",
    "processingSubtitle": "El progreso se actualiza con los datos de Atlas y los cambios de porcentaje se muestran de forma gradual. Si no hay novedades, se mantiene el último valor recibido.",
    "processingGuardTitle": "Atlas debe completar el listado",
    "processingGuardText": "La revisión se abrirá automáticamente cuando Atlas haya identificado y guardado un listado válido.",
    "processingQualityTitle": "Atlas está revisando la lectura",
    "processingQualityText": "La primera lectura no tiene calidad suficiente. Seguimos esperando una interpretación correcta sin mostrar datos defectuosos.",
    "processingTitle": "Atlas está analizando el archivo",
    "queueGlobalLimit_one": "En cola · Capacidad global: {{count}} análisis simultáneo. No es un límite por cliente.",
    "queueGlobalLimit_other": "En cola · Capacidad global: {{count}} análisis simultáneos. No es un límite por cliente.",
    "queueNoUserLimit": "En cola para ejecución. Tu usuario no tiene un límite de análisis simultáneos.",
    "queueUserLimit": "En cola: el límite es de {{count}} análisis simultáneos por usuario. Comenzará automáticamente cuando termine uno de los tuyos.",
    "queueHighDemand": "Hay una alta demanda actualmente. Tu análisis está en cola y comenzará cuando quede capacidad disponible (límite global: {{count}}).",
    "queuePosition": "Posición en cola: {{position}}",
    "processingUpdateErrorTitle": "No hemos podido actualizar el progreso",
    "processingUpdateErrorText": "Atlas continúa trabajando. Volveremos a comprobarlo automáticamente.",
    "sendingPhotoTitle": "Enviando la fotografía a Atlas",
    "sendingPhotoSubtitle": "El escaneo ha terminado. La imagen se está entregando de forma segura para iniciar su lectura.",
    "photoModeTitle": "Fotografía del listado",
    "photoModeHint": "Encaja todos los productos y procura que el texto se lea con claridad.",
    "photoPreviewAlt": "Fotografía del listado de productos",
    "openCamera": "Abrir cámara",
    "scanningPhoto": "Atlas está escaneando la fotografía",
    "projectData": "Datos del proyecto",
    "projectDataHint": "Esta información te ayudará a identificar la solicitud más adelante.",
    "projectName": "Nombre o referencia del proyecto",
    "projectNamePlaceholder": "Ej. Reforma nave logística Norte",
    "reactivateRequest": "Reactivar solicitud",
    "reanalyze": "Re-analizar",
    "reactivatedMessage": "Solicitud reactivada",
    "readingText": "Estamos reconociendo las referencias y las cantidades del documento que has subido. En cuanto termine podrás repasarlo.",
    "readingTitle": "Atlas está leyendo tu listado",
    "removeRow": "Eliminar fila",
    "requestOptions": "Opciones de la solicitud",
    "unidentifiedSummaryTitle": "Productos pendientes",
    "unidentifiedSummaryCount": "{{count}} sin identificar",
    "visualSummaryTitle": "Lecturas por confirmar",
    "visualReadingSaved": "Lectura confirmada",
    "visualIdentificationReady": "Lecturas confirmadas. Ahora selecciona un producto pendiente para responder las preguntas de Atlas.",
    "visualPreparingQuestions": "Lectura guardada. Atlas está preparando las preguntas para identificar los productos…",
    "visualSummaryCount": "{{count}} por confirmar",
    "visualSummaryHint": "Confirma el texto y la cantidad de cada línea. Al terminar, Atlas mostrará las preguntas para elegir los productos.",
    "identifyProduct": "Identificar producto",
    "includedComponentLabel": "Accesorios incluidos de serie",
    "atlasIncludedAccessory": "Incluido · Atlas",
    "atlasCandidateProducts": "Opciones encontradas por Atlas",
    "atlasCandidateProductsHint": "Atlas ha interpretado la necesidad y ha validado estas opciones en el catálogo. Elige la correcta.",
    "atlasGuidedSelectionTitle": "Atlas te ayuda a elegir",
    "atlasIdentityTitle": "Revisar identificación",
    "atlasIdentityHint": "Atlas necesita aclarar qué producto aparece en la imagen; no te está pidiendo elegir sus características.",
    "atlasIdentityField": "Código o referencia",
    "atlasIdentityQuestion": "Comprueba el código o la referencia que aparece en la imagen y corrígelo si es necesario. También puedes utilizar «Buscar en el catálogo» para seleccionar el producto.",
    "atlasIdentityPlaceholder": "Escribe el código o la referencia y, si la conoces, la marca",
    "atlasGuidedSelectionHint": "Selecciona las características y te mostraremos solo el producto compatible.",
    "atlasReplacementTitle": "Alternativas encontradas por Atlas",
    "atlasReplacementHint": "Este producto ya no está disponible. Atlas ha comprobado estas opciones como posibles sustitutos.",
    "discontinuedProduct": "Producto descatalogado",
    "discontinuedCommercialReview": "No hay una sustitución directa confirmada. Un comercial revisará esta línea.",
    "discontinuedAlternativesAvailable": "Atlas ha encontrado alternativas compatibles. Revisa y selecciona la adecuada.",
    "currentProductRange": "gama de productos actual",
    "atlasRackWaiting": "Atlas está calculando el espacio necesario y preparando únicamente los racks compatibles. No necesitas volver a seleccionar los equipos.",
    "atlasRackSizingTitle": "Espacio calculado por Atlas",
    "atlasRackEquipmentUnits": "Equipos: {{count}} U",
    "atlasRackReserveUnits": "Reserva: {{count}} U",
    "atlasRackVentilationUnits": "Ventilación: {{count}} U",
    "atlasRackMinimumUnits": "Mínimo: {{count}} U",
    "atlasRackCompatibleSummary": "Se muestran {{count}} racks compatibles de {{units}} U o más",
    "atlasSelectionStep": "Paso {{step}}",
    "atlasPhoneLinesQuestion": "¿Cuántas líneas de teléfono analógico necesitas conectar a la ONT?",
    "atlasPhoneLinesHint": "Conexiones RJ11 para teléfonos convencionales.",
    "atlasPhoneLines_one": "1 línea de teléfono",
    "atlasPhoneLines_other": "{{count}} líneas de teléfono",
    "atlasNoPhoneLines": "Sin telefonía",
    "atlasAnswerPlaceholder": "Escribe la respuesta",
    "atlasAnaloguePhoneLines_one": "1 línea de teléfono analógico",
    "atlasAnaloguePhoneLines_other": "{{count}} líneas de teléfono analógico",
    "atlasAnaloguePhoneConnections": "conexiones de telefonía analógica",
    "atlasAnalogueTelephony": "telefonía analógica",
    "atlasChooseFormat": "¿Qué formato necesitas?",
    "atlasChooseUsers": "¿Cuántos usuarios debe soportar?",
    "atlasChoosePorts": "¿Cuántos puertos necesitas?",
    "atlasChooseRackUnits": "¿Qué altura necesitas?",
    "atlasChoosePots": "¿Cuántos puertos de telefonía necesitas?",
    "atlasUsersUpTo": "Hasta {{count}} usuarios",
    "atlasUsersRange": "De {{from}} a {{to}} usuarios",
    "atlasPorts": "{{count}} puertos",
    "atlasRackUnits": "{{count}} U",
    "atlasPots": "{{count}} POTS",
    "atlasCompatibleProduct_one": "Producto compatible",
    "atlasCompatibleProduct_other": "Productos compatibles",
    "atlasProductCode": "Código {{code}}",
    "atlasSelectProduct": "Elegir",
    "atlasProductSelected": "Elegido",
    "atlasSearchOtherProduct": "Buscar otro producto en el catálogo",
    "atlasHideCatalogSearch": "Ocultar búsqueda en el catálogo",
    "atlasQuestionsTitle": "Dato necesario para elegir correctamente",
    "recognitionRecommendationsTitle": "Recomendado por Atlas",
    "recognitionRecommendationsHint": "Complementos que Atlas considera necesarios. Podrás decidir sobre ellos en el siguiente paso.",
    "validateEquivalence": "Validar equivalencia",
    "equivalenceValidated": "Equivalencia validada",
    "pendingProductsFooter": "Quedan {{count}} productos por identificar",
    "pendingSuggestionsFooter_one": "Queda 1 producto sugerido por Atlas por confirmar",
    "pendingSuggestionsFooter_other": "Quedan {{count}} productos sugeridos por Atlas por confirmar",
    "pendingEquivalencesFooter": "Quedan {{count}} equivalencias por validar",
    "commercialReviewFooter_one": "1 producto pasará a revisión comercial",
    "commercialReviewFooter_other": "{{count}} productos pasarán a revisión comercial",
    "reviewReadyFooter": "Revisión completa",
    "reviewNavigation": "Navegación de la revisión",
    "reviewList": "Listado",
    "reviewSubtitle": "Comprueba cada línea antes de solicitar el presupuesto.",
    "visualReviewTitle": "Confirmar lectura de la imagen",
    "visualReviewConfirm": "Confirmar lectura",
    "visualEditReading": "Editar lectura",
    "visualReviewConfirming": "Confirmando…",
    "visualLiteralDescription": "Texto leído en la imagen",
    "visualReviewUncertainties": "Datos que conviene revisar",
    "visualTextOptions": "Lecturas propuestas por Atlas",
    "visualQuantityOptions": "Cantidades propuestas por Atlas",
    "visualUnitOptions": "Unidades propuestas por Atlas",
    "visualQuantityAlternatives": "Cantidades posibles: {{values}}",
    "visualUncertainTokens": "Texto dudoso: {{values}}",
    "visualAlternativeReadings": "Otras lecturas posibles: {{values}}",
    "visualReviewReasonGeneric": "Atlas encontró diferencias entre varias lecturas de esta línea.",
    "visualReviewLineHint": "Confirma o corrige primero la lectura. Después Atlas buscará las opciones compatibles.",
    "atlasMoreQuestionsNeeded": "Atlas necesita concretar más características antes de mostrar productos compatibles.",
    "saveDraft": "Guardar borrador",
    "searchCatalog": "Buscar en el catálogo",
    "changeProduct": "Cambiar producto",
    "changeProductHint": "Busca por código o referencia y elige el producto. Solo se cambia el artículo: la cantidad o la unidad pendiente se sigue confirmando aquí.",
    "saveProduct": "Guardar producto",
    "searchCatalogHint": "Escribe un código, una referencia o parte de la descripción y elige el producto: los campos se rellenan solos.",
    "searchPlaceholder": "Buscar por referencia o proyecto",
    "secureText": "Solo se utilizará para preparar y gestionar tu presupuesto.",
    "secureTitle": "Tu información está segura",
    "sendDialogText": "Una vez enviada no podrás editar el listado. Recibirás una notificación cuando el presupuesto esté listo.",
    "sendDialogTitle": "¿Enviar la solicitud a Atlas?",
    "sendRequest": "Enviar solicitud",
    "sentEyebrow": "SOLICITUD ENVIADA",
    "sentOn": "Enviada el {{date}}",
    "sentRef": "Referencia de la solicitud",
    "sentRedirect": "Abriendo el detalle automáticamente en {{seconds}} s.",
    "sentRedirectLabel": "segundos para abrir el detalle automáticamente",
    "sentCountdown": "Mostraremos el seguimiento de Atlas en {{seconds}} s.",
    "sentCountdownLabel": "Segundos para mostrar el seguimiento de Atlas",
    "sentText": "Atlas está preparando tu presupuesto. Te avisaremos en cuanto esté disponible.",
    "sentTitle": "Hemos recibido tu solicitud",
    "startProcessing": "Iniciar procesamiento",
    "stepConfirm": "Confirmación",
    "stepValuation": "Valoración",
    "stepData": "Datos",
    "stepDocuments": "Documentos",
    "stepOf": "Paso {{current}} de {{total}}",
    "stepProcessing": "Procesamiento",
    "stepReview": "Revisión",
    "stepRecommendations": "Recomendaciones",
    "recommendationsTitle": "Completa tu solución",
    "recommendationsSubtitle": "Atlas ha revisado el conjunto completo para detectar productos, licencias o servicios que podrían faltar.",
    "recommendationsAnalyzing": "Atlas está comprobando la solución",
    "recommendationsAnalyzingHint": "Revisa compatibilidades, capacidades y elementos ya incluidos para no duplicar productos.",
    "recommendationsFailed": "Atlas no ha podido completar las recomendaciones.",
    "recommendationsNeedInfo": "Atlas necesita un dato más",
    "recommendationsNeedInfoHint": "Estas respuestas permiten recomendar la variante y la cantidad correctas.",
    "analyzeAnswers": "Analizar respuestas",
    "analyze": "Analizar",
    "imagesReady_one": "1 imagen lista para analizar",
    "imagesReady_other": "{{count}} imágenes listas para analizar",
    "imagesAdded": "Imágenes añadidas",
    "addPhoto": "Añadir foto",
    "recommendationsFound_one": "1 recomendación de Atlas",
    "recommendationsFound_other": "{{count}} recomendaciones de Atlas",
    "recommendationPending": "Pendiente de confirmar",
    "recommendationImportance": {
      "required": "Necesario",
      "recommended": "Recomendado",
      "optional": "Opcional"
    },
    "recommendationCategory": {
      "prerequisite": "Requisito técnico",
      "license": "Licencia",
      "compatibility": "Compatibilidad",
      "accessory": "Accesorio",
      "service": "Servicio"
    },
    "recommendedQuantity": "Cantidad sugerida: {{quantity}} {{unit}}",
    "addRecommendation": "Añadir",
    "replaceRecommendation": "Sustituir",
    "discardRecommendation": "Descartar",
    "recommendationAdded": "Añadido",
    "recommendationReplaced": "Sustituido",
    "replacementOf": "Sustituye a {{products}}",
    "addedByAtlas": "Añadido por recomendación de Atlas",
    "replacedByAtlas": "Sustituido por recomendación de Atlas",
    "siteNumber": "Instalación {{count}}",
    "recommendationDiscarded": "Descartado",
    "notKnownYet": "Todavía no lo sé",
    "noRecommendations": "La solución ya está completa",
    "noRecommendationsHint": "Atlas no ha detectado productos adicionales que debas revisar.",
    "recommendationsQuestionsFooter": "Faltan {{count}} respuestas",
    "recommendationsPendingFooter": "Quedan {{count}} recomendaciones por revisar",
    "recommendationsReadyFooter": "Recomendaciones revisadas",
    "takeAnotherPhoto": "Hacer otra fotografía",
    "takePhoto": "Hacer una fotografía",
    "takePhotoHint": "Usa la cámara de tu dispositivo",
    "titleData": "Cuéntanos sobre el proyecto",
    "titleMaterials": "Documentos del proyecto",
    "uploadFile": "Subir archivo o Excel",
    "uploadFileHint": "PDF, Word, imagen, XLSX, XLS o CSV · Word se convierte a PDF",
    "dragFilesHint": "También puedes arrastrar aquí uno o varios archivos para adjuntarlos.",
    "dropFilesHere": "Suelta los archivos para adjuntarlos",
    "viewBudget": "Ver presupuesto",
    "recognisedSoFar": "Reconocidos: {{count}}",
    "matchEquivalentFrom": "Pedías {{marca}}; te proponemos este equivalente EK",
    "match": {
      "direct": "Leído tal cual",
      "equivalent": "Equivalente EK",
      "none": "No identificado",
      "not_needed": "No hace falta",
      "noEquivalent": "Sin equivalente EK",
      "noEquivalentLong": "Identificado como {{marca}}, pero no tenemos un equivalente EK"
    },
    "showDiscardedRows": "Ver {{count}} filas apartadas del documento",
    "hideDiscardedRows": "Ocultar las filas apartadas",
    "discarded": {
      "headerRow": "Cabecera de la tabla",
      "documentTitle": "Título del documento",
      "partidaRow": "Partida duplicada por su desglose",
      "outsideNumberedTable": "Contenido fuera de la tabla de materiales",
      "unreadableText": "Texto ilegible",
      "otherScope": "Otra partida (mano de obra, servicio u obra civil)",
      "otherBrand": "Producto que no es Ek/Openetics",
      "otherBrandMaker": "Otra marca ({{brands}})",
      "otherBrandFamily": "Fuera del catálogo Ek/Openetics ({{family}})",
      "documentText": "Texto del documento (condiciones, notas)"
    },
    "colProduct": "Producto",
    "colReference": "Referencia",
    "colDescription": "Descripción",
    "documentTechnicalWarning": "Aviso: {{differences}}. Se mantiene el producto identificado.",
    "documentTechnicalDifference": "el documento indica «{{source}}» y el catálogo «{{catalog}}»",
    "colBrand": "Marca de origen",
    "colQuantity": "Cantidad",
    "colUnitPrice": "Precio",
    "colDiscount": "Dto.",
    "colLineSubtotal": "Subtotal",
    "colStatus": "Estado",
    "convertedToEk": "Convertido a EK",
    "groupResolved": "{{resolved}} de {{count}} productos reconocidos",
    "groupExcluded": "{{count}} excluidos",
    "groupsDetected": "{{count}} partidas detectadas",
    "previewSelectCatalogProduct": "Selecciona un producto de los resultados del catálogo para cambiar el código o la referencia.",
    "atlasSuggestion": "Sugerido por Atlas",
    "atlasSuggestionHint": "Alternativa propuesta por Atlas.",
    "reanalyzeDialogTitle": "¿Volver a analizar la solicitud?",
    "reanalyzeDialogText": "Atlas leerá de nuevo los documentos con su versión actual. El listado nuevo sustituirá al actual y se perderán los cambios que hayas hecho en la revisión.",
    "documentReading": {
      "pending": "Lectura documental pendiente de revisión",
      "title": "Confirmar o corregir la lectura",
      "help": "Elige una acción para cada fila o aviso. Una cantidad vacía seguirá pendiente; confirmar el texto no identifica el producto.",
      "fragment": "Fragmento pendiente",
      "action": "Acción de revisión",
      "material": "Confirmar o corregir material",
      "ignore": "Descartar fila / reconocer aviso",
      "text": "Texto leído",
      "quantity": "Cantidad (vacía si es desconocida)",
      "unit": "Unidad del documento",
      "close": "Cerrar",
      "save": "Guardar revisión"
    },
    "recommendationsNavigation": "Navegación de las sugerencias",
    "includedComponentReason": "añadidos automáticamente con el rack {{rack}}, sin coste.",
    "includedComponentReasonGeneric": "añadidos automáticamente con el rack, sin coste.",
    "atlasSuggestionLabel": "Alternativa de Atlas",
    "atlasSuggestionOtherBrand": "Alternativa de {{brand}} (otra marca)",
    "atlasSuggestionDifferences_one": "{{count}} diferencia",
    "atlasSuggestionDifferences_other": "{{count}} diferencias",
    "showDifferences": "Ver diferencias",
    "hideDifferences": "Ocultar diferencias",
    "notInCatalogShort": "Sin equivalente en el catálogo",
    "originalBrandCaption": "En el documento: {{value}}",
    "atlasRackNotCounted": "Atlas no los ha clasificado para el rack y no se suman: {{items}}",
    "atlasRackUnresolved": "Altura en U desconocida, no sumada: {{items}}. El mínimo solo cuenta los equipos con altura conocida.",
    "atlasRackExcluded": "No ocupan el rack: {{items}}",
    "atlasRackWaitingUnits": "Atlas aún no conoce la altura en U de algún equipo del listado y no puede calcular el espacio del rack.",
    "atlasRackWaitingUnitsNamed": "Atlas no puede calcular el espacio del rack: no tiene acreditada la altura en U de {{items}}.",
    "atlasRackSizingTitleCurrent": "Espacio con el listado actual",
    "atlasRackStale": "El listado ha cambiado desde el cálculo de Atlas (mínimo {{minimum}} U): se ha vuelto a sumar con las líneas actuales y las alturas que publicó Atlas.",
    "atlasRackStaleNoRecompute": "El listado ha cambiado desde el cálculo de Atlas y estas cifras pueden no estar al día: revisa el espacio antes de elegir el rack.",
    "atlasRackNotEvaluated": "Atlas no ha evaluado estas líneas para el rack (añadidas o cambiadas en el listado) y no se suman: {{items}}",
    "atlasRackPassive": "Elementos pasivos de rack, que el cálculo no suma: {{items}}",
    "atlasRackRecommendedNotInList": "Atlas también contaba equipos recomendados que no están en el listado: {{items}}",
    "atlasRackStaleSummary": "Con el listado actual hace falta un rack de {{units}} U o más.",
    "atlasRackStaleSummaryMinimum": "Con el listado actual el mínimo es de {{units}} U.",
    "atlasRackCandidateTooSmall": "Tiene menos espacio que el mínimo actual ({{units}} U).",
    "showAtlasNote": "Ver detalle",
    "hideAtlasNote": "Ocultar detalle",
    "showFullNote": "Ver nota completa",
    "showLessNote": "Ver menos de la nota",
    "includesStandardAccessories": "Incluye de serie {{items}}, sin coste: se añade al listado automáticamente.",
    "rackCandidateIncludes": "Si eliges este rack se añade {{items}} al listado: viene de serie, sin coste.",
    "pdfProcessing": {
      "label": "Análisis de documentos con Atlas",
      "document": "Documento",
      "reading": "Lectura",
      "catalog": "Catálogo",
      "upload": "Preparando tu documento",
      "read": "Leyendo tu documento",
      "map": "Buscando en el catálogo",
      "done": "Lectura completada",
      "waiting": "Esperando a Atlas",
      "lines": "Líneas detectadas",
      "matched": "Productos encontrados",
      "files_one": "{{count}} archivo",
      "files_other": "{{count}} archivos",
      "sheet": "Hoja 1",
      "products": "Productos",
      "portal": "Portal del cliente",
      "received": "Recibiendo datos",
      "following": "Seguimiento del análisis",
      "sending": "Documentos → Atlas",
      "returning": "Atlas → Portal",
      "exchange": {
        "prepare": "Preparando tus documentos",
        "send": "Atlas está leyendo tus documentos",
        "reason": "Atlas está procesando el listado",
        "match": "Atlas está asignando referencias",
        "receive": "Recibiendo el resultado en tu portal",
        "waiting": "Esperando a Atlas",
        "checking": "Atlas está comprobando el resultado"
      },
      "atlas": {
        "prepare": "Recibiendo documentos",
        "send": "Leyendo listado",
        "reason": "Procesando listado",
        "match": "Asignando referencias",
        "receive": "Listado preparado",
        "waiting": "En espera",
        "checking": "Comprobando resultado"
      }
    },
    "copyReference": "Copiar referencia de la solicitud",
    "copyReferenceFailed": "No se ha podido copiar la referencia.",
    "validateAllAndContinue": "Validar todo y continuar",
    "validatingAll": "Validando…",
    "partidaOutsideCatalogTitle": "Productos que no son de Ek/Openetics",
    "partidaOutsideCatalogHint_one": "{{count}} producto del proyecto no está en el catálogo. Atlas propone una alternativa equivalente cuando la hay.",
    "partidaOutsideCatalogHint_other": "{{count}} productos del proyecto no están en el catálogo. Atlas propone una alternativa equivalente cuando la hay.",
    "partidaUntitled": "Partida sin título",
    "partidaMeasure": "Medición {{measure}}",
    "partidaProducts_one": "{{count}} producto",
    "partidaProducts_other": "{{count}} productos",
    "atlasScene": {
      "label": "Análisis de Atlas",
      "document": "Documento",
      "waiting": "Esperando a Atlas",
      "phase": {
        "upload": "Preparando tus documentos",
        "extract": "Atlas está separando cada línea del documento",
        "enter": "Las líneas entran en Atlas",
        "master": "Atlas está buscando cada línea en el Máster",
        "compose": "Atlas está componiendo el listado",
        "ready": "Listado preparado",
        "handoff": "Abriendo tu listado"
      },
      "atlas": {
        "upload": "en espera",
        "extract": "leyendo",
        "enter": "recibiendo",
        "master": "consultando el Máster",
        "compose": "componiendo",
        "ready": "listo",
        "handoff": "listo"
      },
      "master": {
        "searching": "Consultando el Máster",
        "done": "Componiendo el listado",
        "badge": "Máster",
        "review": "Comprobando…"
      },
      "list": {
        "title": "Listado",
        "ready": "Tu listado",
        "chip": "Listo"
      },
      "steps": {
        "upload": "Subida",
        "extract": "Extracción",
        "enter": "Envío a Atlas",
        "master": "Máster",
        "compose": "Listado",
        "portal": "Portal"
      },
      "voice": {
        "upload": "Recibiendo tu documento",
        "extract": "Leyendo cada línea",
        "enter": "Pensando",
        "master": "Buscando en el Máster",
        "compose": "Montando tu listado",
        "ready": "Listo",
        "handoff": "Listo",
        "waiting": "Esperando mi turno"
      }
    }
  },
  "requestStatus": {
    "in_progress": "En curso",
    "quote_rejected": "Rechazada en revisión comercial",
    "submission_blocked": "Envío bloqueado",
    "draft": "Borrador",
    "processing": "Leyendo el listado",
    "review": "Pendiente de revisión",
    "submitted": "Preparando presupuesto",
    "quote_review": "Presupuesto en revisión",
    "quote_validated": "Presupuesto validado · pendiente de aceptación",
    "quote_partially_validated": "Presupuesto validado parcialmente · pendiente de revisión",
    "quote_won": "Presupuesto ganado",
    "quote_lost": "Presupuesto perdido",
    "quoted": "Presupuesto disponible",
    "cancelled": "Cancelada",
    "failed": "Error de lectura",
    "ordering": "Pasando a pedido",
    "ordered": "Pedido creado",
    "order_blocked": "Pedido no confirmado"
  },
  "support": {
    "title": "Soporte",
    "subtitle": "Cuéntanos qué necesitas y te responderemos por correo.",
    "topic": "Asunto",
    "topicRequest": "Duda sobre una solicitud",
    "topicBudget": "Duda sobre un presupuesto",
    "topicAccount": "Problema con mi cuenta",
    "topicOther": "Otro asunto",
    "relatedRef": "Referencia relacionada",
    "message": "Mensaje",
    "messagePlaceholder": "Describe tu consulta con el mayor detalle posible…",
    "send": "Enviar consulta",
    "sentTitle": "Hemos recibido tu consulta",
    "sentText": "Te responderemos al correo de tu cuenta en menos de 24 horas laborables.",
    "received": "Consulta enviada"
  },
  "theme": {
    "label": "Tema",
    "light": "Claro",
    "dark": "Oscuro",
    "system": "El del sistema"
  },
  "unitReview": {
    "processing": "Atlas está confirmando la unidad…",
    "pending": "Unidad pendiente de confirmar",
    "line": "Componente",
    "sourceGroup": "Partida de origen",
    "confirm": "Confirmar unidad",
    "change": "Corregir unidad",
    "title": "Confirmar unidad de medida",
    "original": "Unidad original: {{unit}}",
    "source": "Página/hoja {{page}} · fila {{row}} · código {{code}}",
    "quantityUnchanged": "Solo se confirma la unidad de esta línea. No cambia la cantidad, otra línea ni la partida documental.",
    "choose": "Elige una unidad admitida",
    "separateAction": "Confirma o corrige la unidad desde la acción específica de la fila; elegir un producto no la confirma.",
    "blocked": "Confirma las unidades pendientes de las líneas de material antes de continuar.",
    "returnToReview": "Revisar unidades",
    "orderBlocked": "No se puede aceptar el pedido mientras haya unidades pendientes. Revisa la solicitud vinculada.",
    "notSynchronized": "La unidad no se ha aplicado: Atlas no ha confirmado el cambio y la línea sigue pendiente. Vuelve a confirmarla."
  },
  "units": {
    "ud": "ud",
    "m": "m",
    "kg": "kg",
    "h": "h",
    "box": "caja"
  },
  "atlasPending": {
    "title": "Pendientes de Atlas",
    "help": "Pulsa un producto para responder a Atlas y completar su identificación.",
    "fullDescription": "Descripción completa"
  },
  "installation": {
    "comingSoon": "Próximamente",
    "describeTitle": "Describe tu instalación a Atlas",
    "describeHint": "Atlas prepara los materiales a partir de lo que necesitas",
    "steps": {
      "description": "Tu instalación",
      "details": "Detalles",
      "materials": "Materiales",
      "suggestions": "Sugerencias",
      "technicalReview": "Revisión técnica",
      "confirmation": "Confirmación"
    },
    "phases": {
      "revision": "Revisión de materiales",
      "confirmar": "Confirmación del presupuesto"
    },
    "newRequestNotice": "Esta solicitud ya contiene materiales o documentos. Al enviar la descripción, crearemos otra solicitud con los mismos datos del proyecto y conservaremos esta.",
    "restartNotice": "Si vuelves a enviar la descripción, Atlas iniciará un análisis nuevo y te pedirá de nuevo los detalles necesarios.",
    "tellUs": "Cuéntanos qué necesitas",
    "descriptionLabel": "Tu instalación",
    "descriptionHelp": "Describe el objetivo, las dimensiones, los equipos existentes y cualquier requisito que debamos tener en cuenta.",
    "useExample": "Usar un ejemplo de descripción",
    "example": "Quiero mejorar el Wi-Fi de una oficina de una planta con cuatro despachos. Ya tengo router y cableado de red. Necesito puntos de acceso para unos veinte usuarios y quiero saber qué otros equipos hacen falta.",
    "proposalTitle": "Tu propuesta de materiales",
    "technicalPendingTitle": "Pendiente de comprobaciones técnicas",
    "atlasUpdatePendingTitle": "Pendiente de actualización de Atlas",
    "resolveHint": "No necesitas volver a responder. Atlas debe completar la selección con la documentación y las alternativas disponibles.",
    "noMoreQuestions": "Atlas no tiene más preguntas para ti en este momento. Tu solicitud está guardada y puedes retomarla desde Inicio.",
    "previewNotice_one": "El material es una vista previa. Podrás confirmarlo, editarlo o quitarlo cuando Atlas termine sus comprobaciones.",
    "previewNotice_other": "Los {{count}} materiales son una vista previa. Podrás confirmar, editar o quitar cada uno cuando Atlas termine sus comprobaciones.",
    "correctDescription": "Corregir la descripción",
    "blockersNotice": "Antes de mostrar una propuesta lista para confirmar, quedan estas comprobaciones pendientes.",
    "atlasDetails": "Ver detalles de Atlas",
    "noProposalYet": "Todavía no hay una propuesta disponible. Consulta el estado para comprobar si hay novedades.",
    "clarifyTitle": "Aclaremos tu instalación",
    "clarifyHint": "Pulsa en cada tema para responder paso a paso. Después enviaremos tus respuestas a Atlas.",
    "retryableFailure": "Atlas no ha podido terminar el análisis por una interrupción temporal. Tus respuestas están guardadas. Puedes reintentarlo sin empezar de nuevo.",
    "failure": "Atlas no ha podido completar la propuesta. Puedes revisar la descripción y volver a intentarlo.",
    "plannerUnavailableTitle": "Atlas no ha podido planificar la instalación ahora mismo",
    "plannerUnavailableText": "Tu descripción se conserva. Puedes volver a intentarlo en unos minutos o rellenar tú mismo el listado de productos; Atlas los identificará en el catálogo al continuar.",
    "plannerRetry": "Volver a intentarlo",
    "awaitingConfirmation": "Pendiente de tu confirmación",
    "whyComponents": "Por qué estos componentes",
    "youDecideTitle": "Tú decides qué entra en el presupuesto",
    "youDecideText": "Primero resolveremos los detalles que faltan. Después podrás revisar los materiales, entender su elección y añadir mejoras opcionales.",
    "yourDescription": "Tu descripción",
    "atlasObservations": "Observaciones de Atlas",
    "referenceFiles": "Archivos de referencia",
    "optionalTag": "(opcional)",
    "confirmedCount": "{{confirmed}} de {{total}} materiales confirmados.",
    "provisionalCount_one": "1 material provisional · Pendiente de Atlas",
    "provisionalCount_other": "{{count}} materiales provisionales · Pendiente de Atlas",
    "detailsCompleted": "{{done}} de {{total}} detalles completados",
    "retrying": "Reintentando análisis…",
    "resolving": "Revisando con Atlas…",
    "checking": "Consultando…",
    "preparingAction": "Preparando propuesta…",
    "retry": "Reintentar análisis",
    "resolve": "Resolver con Atlas",
    "checkStatus": "Consultar estado",
    "sendDescription": "Enviar propuesta",
    "reviewDescription": "Revisar descripción",
    "sendAnswers": "Enviar respuestas",
    "reviewTopic": "Revisar: {{topic}}",
    "clarifyTopic": "Aclarar: {{topic}}",
    "answersSaved": "Respuestas guardadas. Puedes revisarlas.",
    "stepsToClarify_one": "1 paso para aclararlo",
    "stepsToClarify_other": "{{count}} pasos para aclararlo",
    "tapToAnswer": "Pulsa para responder",
    "completed": "Completado",
    "pending": "Pendiente",
    "clarifyDetail": "Aclara este detalle",
    "closeKeepAnswers": "Cerrar y conservar respuestas",
    "previous": "Anterior",
    "backToQuestions": "Volver a las preguntas",
    "next": "Siguiente",
    "saveAnswers": "Guardar respuestas",
    "selectOption": "Selecciona una opción",
    "quantity": "Cantidad",
    "yourAnswer": "Tu respuesta",
    "optionalAnswer": "Opcional. Puedes continuar sin responder.",
    "whyAtlasAsks": "¿Por qué lo pregunta Atlas?",
    "preparingTitle": "Atlas está preparando tu instalación",
    "preparingText": "Estamos revisando tu descripción y los productos del catálogo.",
    "preparingProgress": "Atlas está preparando la propuesta",
    "preparingLeave": "Puedes salir y volver a esta solicitud para continuar.",
    "columns": {
      "code": "Código",
      "reference": "Referencia",
      "name": "Descripción corta",
      "quantity": "Cantidad",
      "actions": "Acciones"
    },
    "proposalTableLabel": "Materiales propuestos por Atlas",
    "allRemoved": "Has quitado todos los materiales. Vuelve a tu descripción para preparar otra propuesta.",
    "confirmItem": "Confirmar {{name}}",
    "editItem": "Editar {{name}}",
    "itemConfirmed": "{{name}} confirmado",
    "remove": "Quitar",
    "removeItem": "Quitar {{name}}",
    "userCatalogReason": "Producto seleccionado por ti en el catálogo. Su adecuación a la instalación está pendiente de revisión.",
    "referencesHint": "Añade planos, fotos o documentos para ayudar a Atlas a entender la instalación.",
    "removeFile": "Quitar archivo",
    "savingReferences": "Guardando archivos de referencia",
    "referencesLocked": "Para cambiar estos archivos, reinicia el análisis de la propuesta.",
    "changeFiles": "Cambiar archivos",
    "savingFiles": "Guardando archivos…",
    "attachFiles": "Adjuntar archivos",
    "attachReferences": "Adjuntar archivos de referencia",
    "referencesLimits": "PDF, JPG, PNG o WebP. Hasta 5 archivos, 10 MB por archivo y 20 MB en total.",
    "changeReferencesTitle": "Cambiar archivos de referencia",
    "changeReferencesText": "Se conservarán la descripción y los archivos. Después de cambiarlos tendrás que enviar la propuesta de nuevo; Atlas volverá a analizarla y las respuestas del análisis anterior no se utilizarán.",
    "verificationTitle": "Revisión técnica de Atlas",
    "verified": "Atlas ha verificado este listado. Ya puedes revisar el resumen y confirmar la solicitud.",
    "verifying": "Atlas está revisando los productos, las cantidades y su compatibilidad…",
    "verificationQuestions": "Atlas necesita estos detalles para validar tu instalación",
    "verificationBlocked": "La revisión no permite confirmar todavía. Revisa las observaciones de Atlas y corrige el listado o completa los detalles.",
    "verificationIntro": "Antes de confirmar, Atlas comprobará la instalación con el listado que has revisado y las mejoras seleccionadas.",
    "reviewMaterials": "Revisar materiales",
    "listVerified": "Listado verificado",
    "verificationRunning": "Revisión en curso",
    "verificationPending": "Pendiente de revisión",
    "verifyWithAtlas": "Revisar con Atlas",
    "suggestionsTitle": "Completa tu instalación",
    "suggestionsHint": "Revisa las sugerencias de Atlas y decide cuáles quieres añadir a tu propuesta.",
    "backToProposal": "Volver a la propuesta",
    "observations": {
      "analysisNeedsInput": "Completa los detalles que Atlas necesita para revisar la instalación.",
      "lineRevision": "Revisa los materiales: Atlas ha detectado componentes necesarios o incompatibilidades pendientes de resolver.",
      "mandatoryDependencies": "Faltan componentes necesarios para que la instalación funcione. Revisa las sugerencias de Atlas.",
      "catalogChanged": "El catálogo ha cambiado. Revisa los productos antes de volver a validar la instalación.",
      "catalogMismatch": "Atlas debe corregir las referencias o unidades que no coinciden con el catálogo antes de mostrar los materiales.",
      "pending": "Hay una comprobación pendiente de Atlas.",
      "reviewNeeded": "Atlas necesita que revises la instalación antes de continuar."
    },
    "plannerReadAsList": "Que Atlas lo lea como listado",
    "typedTextPlannerNotice": "Atlas ha leído tu texto y describe una instalación, no un listado de productos: prepara la propuesta de instalación con esta misma descripción.",
    "materialListBlockedTitle": "No hemos podido leer el listado en esta solicitud",
    "materialListBlockedText": "Tu listado se conserva. Esta solicitud ha cambiado mientras lo escribías y no admite el listado ahora. Puedes hacer que Atlas lo lea en una solicitud nueva con los mismos datos del proyecto o rellenar los productos a mano.",
    "materialListNewRequest": "Leerlo en una solicitud nueva"
  },
  "adaltra": {
    "portal": "Portal del cliente",
    "workspace": "Tu espacio de trabajo",
    "helpTitle": "Estamos para ayudarte",
    "helpBody": "Te ayudamos con tus solicitudes y presupuestos.",
    "helpAction": "Contactar con soporte",
    "skip": "Ir al contenido",
    "openMenu": "Abrir menú",
    "closeMenu": "Cerrar menú",
    "navigation": "Navegación principal",
    "activity": "Tu portal",
    "account": "Tu cuenta",
    "search": "Buscar solicitudes",
    "searchHint": "Buscar solicitudes por nombre o referencia…",
    "noResults": "No se han encontrado secciones",
    "welcome": "Bienvenido a tu portal",
    "client": "Cliente",
    "team": "Equipo ADALTRA",
    "navigate": "Buscar una sección",
    "navigateHint": "Ir a una sección…",
    "searchSubmit": "Buscar solicitudes",
    "expandSidebar": "Desplegar menú",
    "collapseSidebar": "Plegar menú"
  },
  "pdfLab": {
    "nav": "Lectura de PDF",
    "title": "Lee tu documento antes de enviarlo",
    "eyebrow": "Documentos / Atlas",
    "subtitle": "Extrae el texto, revisa los productos y prepara únicamente lo que Atlas necesita.",
    "drop": "Arrastra tus documentos aquí",
    "formats": "PDF, JPG y PNG · Hasta 15 MB por archivo y 60 páginas en total",
    "select": "Seleccionar documentos",
    "forceOcr": "Forzar OCR en todas las páginas",
    "readAgain": "Volver a leer",
    "progressOcr": "Reconociendo la página {{page}} con OCR…",
    "progressText": "Extrayendo texto de la página {{page}}…",
    "tooLarge": "El archivo está vacío o supera los 15 MB.",
    "tooManyPages": "Los documentos superan el límite de 60 páginas. Divide el archivo.",
    "tooManyPixels": "La página es demasiado grande para procesarla en el navegador.",
    "unsupported": "Selecciona un PDF, JPG o PNG válido.",
    "unreadable": "No se ha podido leer el documento. Comprueba si está dañado o protegido con contraseña.",
    "pageCount": "{{count}} páginas",
    "lineCount": "{{count}} productos leídos",
    "ocrCount": "{{count}} páginas con OCR",
    "reviewHint": "Revisa referencias, descripciones, cantidades y unidades antes de enviar. El original se conserva en tu equipo. No se envía ningún PDF a Atlas.",
    "products": "Productos del documento",
    "identify": "Comprobar en el catálogo",
    "identifying": "Consultando catálogo…",
    "include": "Incluir",
    "reference": "Referencia",
    "description": "Descripción",
    "quantity": "Cantidad",
    "unit": "Unidad",
    "brand": "Marca",
    "status": "Identificación",
    "exact": "Coincidencia exacta",
    "approximate": "Candidatos por revisar",
    "unmatched": "Sin coincidencia",
    "unavailable": "Catálogo no disponible",
    "pending": "Sin comprobar",
    "pages": "Texto original por página",
    "page": "Página {{page}}",
    "embedded": "Texto del PDF",
    "sourceText": "Texto original",
    "onlyLines": "Preparar solo las líneas de producto seleccionadas",
    "preparedText": "Texto que se enviará a Atlas",
    "textCount": "{{count}} caracteres · No se trunca el contenido automáticamente.",
    "download": "Descargar texto",
    "send": "Enviar texto revisado a Atlas",
    "sending": "Enviando texto…",
    "textUnsupported": "Esta conexión de Atlas todavía no admite texto. Puedes descargarlo. No se enviará el PDF como alternativa.",
    "textTooLong": "El texto supera los límites que admite esta conexión de Atlas. Revisa la selección o prepara solicitudes separadas; no se enviará un texto recortado.",
    "sendError": "No se ha podido enviar el texto. Revisa el estado de la solicitud antes de reintentarlo.",
    "newDraftRequired": "Para usar la lectura PDF previa, abre una solicitud nueva sin documentos ni productos. La solicitud actual se conserva.",
    "pageCount_one": "1 página",
    "lineCount_one": "1 producto leído",
    "ocrCount_one": "1 página con OCR",
    "editLine": "Corregir producto leído",
    "reviewTitle": "Revisa los productos leídos",
    "reviewSubtitle": "Comprueba cantidades y referencias. Puedes corregir cada producto antes de continuar.",
    "uploadTitle": "Añade tus documentos",
    "uploadSubtitle": "Leeremos el texto y las páginas escaneadas antes de enviarlas a Atlas.",
    "changeMethod": "Cambiar método",
    "textCountShort": "{{count}} caracteres"
  },
  "preferences": {
    "title": "Preferencias",
    "subtitle": "Elige qué avisos quieres recibir y por qué canal.",
    "notifications": "Tipos de avisos",
    "description": "Tus preferencias se guardan en tu cuenta y se aplican en todos tus dispositivos.",
    "deliveryHint": "El correo y los avisos push dependen de los canales habilitados por la empresa. Para recibir push, activa también los avisos en este dispositivo. Los correos de acceso y seguridad se mantienen.",
    "saved": "Preferencias guardadas.",
    "channels": {
      "email": "Correo",
      "portal": "Portal",
      "push": "Push"
    },
    "categories": {
      "requests": {
        "title": "Solicitudes",
        "description": "Envío, recepción y finalización de la lectura."
      },
      "budgets": {
        "title": "Presupuestos",
        "description": "Disponibilidad, revisiones y cambios de estado."
      },
      "reminders": {
        "title": "Recordatorios",
        "description": "Avisos para revisar presupuestos pendientes."
      },
      "incidents": {
        "title": "Incidencias",
        "description": "Errores de lectura o de preparación del presupuesto."
      },
      "updates": {
        "title": "Novedades y otros avisos",
        "description": "Comunicaciones generales y avisos internos."
      }
    }
  },
  "twoFactor": {
    "title": "Verificación en 2 pasos",
    "body": "Hemos enviado un código de 6 dígitos a",
    "codeLabel": "Código de verificación",
    "submit": "Verificar y entrar",
    "notReceived": "¿No lo has recibido?",
    "resend": "Reenviar",
    "resendIn": "Reenviar ({{time}})",
    "expired": "La sesión de verificación ha caducado. Vuelve a acceder."
  },
  "adaltraProfile": {
    "roles": {
      "client": "Cliente",
      "commercial": "Comercial",
      "manager": "Gestor",
      "admin": "Administrador",
      "orders": "Pedidos"
    },
    "protection": "Tu cuenta, protegida",
    "protectionHint": "Verificación en dos pasos por correo electrónico. Validamos tu acceso con un código de un solo uso.",
    "devicesHint": "Los navegadores que hayas validado pueden recordarse durante 30 días. Puedes retirar la confianza de todos ellos.",
    "forgetDevices": "Olvidar dispositivos",
    "devicesRevoked": "Se ha retirado la confianza de tus dispositivos.",
    "passwordHint": "Actualiza tu contraseña para proteger tu cuenta."
  },
  "stock": {
    "customerOrdersTitle": "Pedidos pendientes de servir a clientes",
    "reportedDate": "Fecha informada: {{value}}",
    "customerOrdersCount": "Número de pedidos comunicado: {{value}}",
    "customerOrdersUnavailable": "Desglose de pedidos no disponible",
    "customerOrdersEmpty": "El listado recibido no contiene pedidos pendientes.",
    "orderCustomer": "Cliente",
    "customerOrderNumber": "N.º pedido cliente",
    "orderDate": "Fecha del pedido",
    "deliveryDate": "Fecha de entrega",
    "orderQuantity": "Cantidad",
    "explanation": "Ver explicación recibida",
    "ordersAndCommitments": "Pedidos y compromisos",
    "pendingCustomers": "Pendiente de servir a clientes",
    "supplierOrders": "En pedido a proveedores",
    "totalCommitted": "Comprometido total",
    "remainingAfterRequest": "Remanente tras la operación",
    "warehouses": "Stock físico por almacén",
    "warehouse": "Almacén",
    "warehouseUnavailable": "Desglose por almacén no disponible",
    "supplyArrivals": "Entradas previstas de proveedor",
    "purchaseOrdersCount": "Pedidos de compra: {{value}}",
    "expectedDate": "Fecha prevista",
    "purchaseOrder": "Pedido",
    "noArrivalDate": "Sin fecha prevista",
    "nextArrival": "Próxima llegada: {{value}}",
    "noIndicator": "Sin semáforo",
    "column": "Stock",
    "available": "Disponible: {{value}}",
    "unknown": "Desconocido",
    "not_queried": "Stock no consultado",
    "unavailable": "Stock no disponible",
    "not_applicable": "No aplica",
    "physical": "Físico",
    "virtual": "Virtual",
    "committed": "Comprometido total",
    "checkedAt": "Consultado (hora de España): {{value}}",
    "requested": "Contexto de la consulta: {{value}} {{unit}}",
    "notComparable": "No está acreditada la comparación con la cantidad solicitada.",
    "reason": "Motivo: {{value}}",
    "informational": "Consulta informativa. No reserva material ni garantiza el suministro.",
    "details": "Ver detalle de stock. {{summary}}",
    "green": "Semáforo verde de Atlas",
    "amber": "Semáforo ámbar de Atlas",
    "red": "Semáforo rojo de Atlas",
    "article": "Artículo",
    "requestedColumn": "Cantidad solicitada",
    "physicalVirtual": "Stock físico / virtual",
    "committedColumn": "Comprometido total",
    "availableColumn": "Disponible efectivo",
    "indicatorColumn": "Semáforo",
    "dialogTitle": "Stock del producto",
    "minimumPurchase": "Cantidad mínima de compra: {{value}}",
    "minimumPurchasePackaging": "Cantidad mínima de compra: {{value}} (embalaje {{packaging}})",
    "minimumPurchaseShort": "Mín. {{value}}",
    "metric": "Concepto",
    "checking": "Consultando stock…",
    "multipleOrders": "Varios pedidos: {{value}}",
    "yes": "Sí",
    "no": "No",
    "level": "Nivel: {{value}}",
    "sharedProductTotal": "El semáforo y el remanente corresponden al total de este producto en el listado; no a un reparto por línea.",
    "stale": "La consulta ha caducado. Actualiza el stock para obtener datos vigentes.",
    "purchaseBasisUnknown": "No se ha podido verificar la unidad o base de compra del producto.",
    "identityUnverified": "No se ha podido verificar el producto en el catálogo.",
    "sourceUnavailable": "El servicio de stock no está disponible en este momento.",
    "reasonUnknown": "Atlas no ha podido verificar un dato de stock vigente."
  },
  "stockSearch": {
    "productImage": "Imagen de {{reference}}",
    "imageUnavailable": "Imagen no disponible",
    "hint": "Buscar solicitudes o stock por código / referencia…",
    "label": "Buscar solicitudes o stock de productos",
    "requests": "Buscar solicitudes con este texto",
    "not_found": "Escribe el código o la referencia completa de un producto para consultar su stock.",
    "ambiguous": "La referencia coincide con varios productos. Introduce el código completo para identificarlo.",
    "unavailable": "No se ha podido consultar el producto. Vuelve a intentarlo."
  },
  "closedOrder": {
    "confirmTitle": "Confirmar pedido",
    "confirmSubtitle": "Revisa el pedido cerrado antes de enviarlo a Atlas. No se añadirán recomendaciones ni se cambiarán sus cantidades.",
    "stockNotice": "Atlas indica limitaciones de stock en algunos productos. Consulta su semáforo para ver el detalle; puedes enviar el pedido sin cambiar sus artículos ni cantidades. El stock es informativo y no reserva material.",
    "send": "Enviar a Atlas",
    "dialogTitle": "¿Enviar este pedido a Atlas?",
    "dialogText": "Se enviará el listado que has revisado, sin añadir recomendaciones. Comprueba los artículos y cantidades antes de confirmar.",
    "reviewSubtitle": "Comprueba los artículos y cantidades del pedido antes de enviarlo a Atlas.",
    "reviewedNote": "Este pedido incluye únicamente los materiales y cantidades del listado que has revisado."
  },
  "productThumbnail": {
    "image": "Imagen de {{reference}}",
    "unavailable": "Imagen del producto no disponible"
  },
  "customerOrder": {
    "action": "Ganado y pasar a pedido",
    "dialogTitle": "¿Marcar como ganado y pasar a pedido?",
    "dialogText": "Atlas enviará {{ref}} a Ada-quote, marcará el presupuesto como GANADO y lo convertirá en PEDIDO con el cliente, la dirección, la fecha de entrega y el número de pedido del paso 1. Esta acción crea un pedido real.",
    "retry": "Reintentar",
    "confirmedDetail": "Pedido {{order}} · Presupuesto {{quote}}",
    "providerError": "Ada-quote ha respondido: {{code}}",
    "state": {
      "requested": "Preparando el pedido…",
      "submission_failed": "No se ha podido enviar la solicitud",
      "pending_creation": "Creando el presupuesto en Ada-quote…",
      "sending": "Pasando a pedido…",
      "confirmed": "Presupuesto ganado y pasado a pedido",
      "rejected": "Ada-quote ha rechazado el pedido",
      "uncertain": "No se ha podido confirmar el pedido"
    },
    "refresh": "Actualizar estado",
    "processingTitle": "Pasando a pedido",
    "processingText": "Atlas está marcando el presupuesto como ganado y creando el pedido en Ada-quote.",
    "processingHint": "Puedes cerrar esta página: el pedido sigue en marcha.",
    "step": {
      "sending": "Enviando la solicitud a Atlas",
      "quote": "Preparando el presupuesto en Ada-quote",
      "won": "Marcando el presupuesto como ganado",
      "order": "Creando el pedido",
      "pack": "Preparando el pedido",
      "send": "Enviando el pedido a MTR",
      "wait": "Esperando la confirmación de MTR…"
    },
    "orderLabel": "Pedido",
    "quoteLabel": "Presupuesto",
    "totalLabel": "Total",
    "deliveryLabel": "Entrega",
    "customerOrderNumberLabel": "Pedido cliente",
    "stamp": "GANADO"
  },
  "maintenance": {
    "banner": "Atlas está en mantenimiento. Puedes crear solicitudes y subir documentos: al pulsar «Analizar» quedarán en cola y se procesarán automáticamente al terminar.",
    "until": "Previsto hasta las {{time}}.",
    "title": "Modo mantenimiento",
    "active": "Activo",
    "inactive": "Desactivado",
    "description": "Con el modo activo, «Analizar» deja las solicitudes en cola y Atlas no empieza lecturas nuevas; lo que ya está en curso termina. Al desactivarlo, la cola se envía sola por orden de llegada. Se desactiva solo a las 2 horas.",
    "since": "Activo desde {{time}}",
    "estimate": "previsto hasta {{time}}",
    "expires": "se desactiva solo a las {{time}}",
    "message": "Mensaje para los usuarios (opcional)",
    "minutes": "Duración estimada (min)",
    "processing_one": "{{count}} lectura en curso",
    "processing_other": "{{count}} lecturas en curso",
    "queued_one": "{{count}} solicitud en cola",
    "queued_other": "{{count}} solicitudes en cola",
    "turnOn": "Activar mantenimiento",
    "turnOff": "Desactivar y enviar la cola",
    "queuedTitle": "Solicitud en cola",
    "queuedText": "Atlas está en mantenimiento. Tu solicitud está guardada en cola y se enviará a Atlas automáticamente en cuanto termine; te avisaremos cuando empiece a procesarse. Puedes cerrar esta pantalla.",
    "queuedHome": "Ir al inicio"
  }
}
